// GENERATED FILE - do not edit by hand. Regenerate with:
//   node scripts/generate-city-yield-facts.mjs
// Source: scripts/generate-city-yield-facts.mjs, city list scripts/data/top-250-german-cities.json
// (see scripts/data/README.md), yield data from the public PVGIS PVcalc API
// (https://re.jrc.ec.europa.eu/api/v5_2/PVcalc), Süd-Ausrichtung/35°-Neigung-Referenzwert
// (Roofora's eigene idealPitchDegrees, siehe PvCalculationService.kt) - generated 2026-08-05.
//
// annualYieldKwhPerKwp: PVGIS-Jahresertrag pro kWp installierter Leistung unter der
// Referenz-Annahme oben, keine Rooforas eigene, kalibrierte Preis-/Sizing-Zahl (die bleibt
// unverändert in PvCalculationService.kt/WeatherProperties) - siehe Task-08-Dokument für die
// Begründung, warum diese Zahl bewusst aus einer separaten Quelle kommt.
// monthlyShare: 12 Werte, Summe = 1 (relative Monatsverteilung, gleiche Normalisierung wie
// JrcPvgisClient.kt's fetchMonthlyProductionShape).
// rank: 1 = höchster Ertrag von den 250 Städten.

export interface CityYieldFact {
  name: string
  slug: string
  plz: string
  bundesland: string
  population: number
  annualYieldKwhPerKwp: number
  monthlyShare: number[]
  rank: number
}

export const NATIONAL_AVERAGE_YIELD_KWH_PER_KWP = 1047.2

export const CITY_YIELD_FACTS: CityYieldFact[] = [
  {
    name: "Singen",
    slug: "singen",
    plz: "78224",
    bundesland: "Baden-Württemberg",
    population: 47621,
    annualYieldKwhPerKwp: 1153.4,
    monthlyShare: [0.039552, 0.055540, 0.091754, 0.108999, 0.111981, 0.115466, 0.121735, 0.111539, 0.097485, 0.068441, 0.043714, 0.033795],
    rank: 1,
  },
  {
    name: "Lörrach",
    slug: "loerrach",
    plz: "79540",
    bundesland: "Baden-Württemberg",
    population: 47002,
    annualYieldKwhPerKwp: 1150.7,
    monthlyShare: [0.041817, 0.055869, 0.089517, 0.106802, 0.107775, 0.112972, 0.119550, 0.111034, 0.097347, 0.073023, 0.046736, 0.037559],
    rank: 2,
  },
  {
    name: "Ravensburg",
    slug: "ravensburg",
    plz: "88214",
    bundesland: "Baden-Württemberg",
    population: 48825,
    annualYieldKwhPerKwp: 1145.9,
    monthlyShare: [0.040352, 0.056653, 0.087467, 0.109039, 0.110339, 0.113446, 0.119747, 0.111509, 0.097031, 0.073417, 0.045082, 0.035919],
    rank: 3,
  },
  {
    name: "Friedrichshafen",
    slug: "friedrichshafen",
    plz: "88045",
    bundesland: "Baden-Württemberg",
    population: 58403,
    annualYieldKwhPerKwp: 1141,
    monthlyShare: [0.041534, 0.057809, 0.093305, 0.110299, 0.112052, 0.114707, 0.120553, 0.110387, 0.095812, 0.068888, 0.041552, 0.033103],
    rank: 4,
  },
  {
    name: "Filderstadt",
    slug: "filderstadt",
    plz: "70794",
    bundesland: "Baden-Württemberg",
    population: 43550,
    annualYieldKwhPerKwp: 1138.7,
    monthlyShare: [0.039993, 0.055213, 0.089480, 0.108221, 0.110434, 0.114649, 0.118162, 0.109389, 0.095197, 0.071775, 0.048020, 0.039466],
    rank: 5,
  },
  {
    name: "Konstanz",
    slug: "konstanz",
    plz: "78462",
    bundesland: "Baden-Württemberg",
    population: 81275,
    annualYieldKwhPerKwp: 1138,
    monthlyShare: [0.040896, 0.054455, 0.090764, 0.110632, 0.113171, 0.116546, 0.121783, 0.112310, 0.096291, 0.068347, 0.041441, 0.033365],
    rank: 6,
  },
  {
    name: "Memmingen",
    slug: "memmingen",
    plz: "87700",
    bundesland: "Bayern",
    population: 44192,
    annualYieldKwhPerKwp: 1135.4,
    monthlyShare: [0.040515, 0.057126, 0.085689, 0.108518, 0.110103, 0.112719, 0.118365, 0.111865, 0.094787, 0.073252, 0.048468, 0.038595],
    rank: 7,
  },
  {
    name: "Tübingen",
    slug: "tuebingen",
    plz: "72072",
    bundesland: "Baden-Württemberg",
    population: 92322,
    annualYieldKwhPerKwp: 1133.6,
    monthlyShare: [0.039856, 0.055232, 0.088868, 0.107226, 0.109599, 0.114927, 0.117547, 0.110631, 0.096287, 0.071613, 0.048642, 0.039573],
    rank: 8,
  },
  {
    name: "Bietigheim-Bissingen",
    slug: "bietigheim-bissingen",
    plz: "74321",
    bundesland: "Baden-Württemberg",
    population: 43556,
    annualYieldKwhPerKwp: 1129.4,
    monthlyShare: [0.039853, 0.053577, 0.088338, 0.110660, 0.112970, 0.115494, 0.118256, 0.110730, 0.096148, 0.071303, 0.045927, 0.036745],
    rank: 9,
  },
  {
    name: "Rottenburg",
    slug: "rottenburg",
    plz: "72108",
    bundesland: "Baden-Württemberg",
    population: 42721,
    annualYieldKwhPerKwp: 1128.1,
    monthlyShare: [0.042177, 0.055403, 0.089018, 0.106889, 0.108803, 0.114565, 0.117234, 0.109982, 0.095968, 0.071670, 0.048418, 0.039873],
    rank: 10,
  },
  {
    name: "Bruchsal",
    slug: "bruchsal",
    plz: "76646",
    bundesland: "Baden-Württemberg",
    population: 47784,
    annualYieldKwhPerKwp: 1127.8,
    monthlyShare: [0.036098, 0.052635, 0.087146, 0.113331, 0.116328, 0.118296, 0.120221, 0.112621, 0.097370, 0.070281, 0.043555, 0.032117],
    rank: 11,
  },
  {
    name: "Rastatt",
    slug: "rastatt",
    plz: "76437",
    bundesland: "Baden-Württemberg",
    population: 47906,
    annualYieldKwhPerKwp: 1127.5,
    monthlyShare: [0.037711, 0.052815, 0.088379, 0.111829, 0.114746, 0.119314, 0.120387, 0.112893, 0.098277, 0.069444, 0.042367, 0.031840],
    rank: 12,
  },
  {
    name: "Böblingen",
    slug: "boeblingen",
    plz: "71032",
    bundesland: "Baden-Württemberg",
    population: 46282,
    annualYieldKwhPerKwp: 1127.1,
    monthlyShare: [0.041505, 0.055835, 0.089106, 0.107055, 0.110267, 0.114987, 0.116966, 0.108874, 0.094767, 0.072169, 0.048674, 0.039793],
    rank: 13,
  },
  {
    name: "Karlsruhe",
    slug: "karlsruhe",
    plz: "76133",
    bundesland: "Baden-Württemberg",
    population: 283799,
    annualYieldKwhPerKwp: 1126.3,
    monthlyShare: [0.037253, 0.053607, 0.087478, 0.112737, 0.115178, 0.117904, 0.120186, 0.113278, 0.096845, 0.070130, 0.043388, 0.032015],
    rank: 14,
  },
  {
    name: "Freising",
    slug: "freising",
    plz: "85356",
    bundesland: "Bayern",
    population: 42570,
    annualYieldKwhPerKwp: 1126.3,
    monthlyShare: [0.039057, 0.052943, 0.087498, 0.112252, 0.113086, 0.115696, 0.121716, 0.113059, 0.093393, 0.071641, 0.042963, 0.036695],
    rank: 15,
  },
  {
    name: "Esslingen",
    slug: "esslingen",
    plz: "73728",
    bundesland: "Baden-Württemberg",
    population: 92390,
    annualYieldKwhPerKwp: 1124.9,
    monthlyShare: [0.040805, 0.055794, 0.088687, 0.108458, 0.110138, 0.115294, 0.118228, 0.110191, 0.095194, 0.070996, 0.047553, 0.038663],
    rank: 16,
  },
  {
    name: "Ludwigsburg",
    slug: "ludwigsburg",
    plz: "71638",
    bundesland: "Baden-Württemberg",
    population: 87603,
    annualYieldKwhPerKwp: 1124.4,
    monthlyShare: [0.041019, 0.055329, 0.089446, 0.109741, 0.111600, 0.114562, 0.117301, 0.109172, 0.095227, 0.071382, 0.046960, 0.038261],
    rank: 17,
  },
  {
    name: "Stuttgart",
    slug: "stuttgart",
    plz: "70173",
    bundesland: "Baden-Württemberg",
    population: 612663,
    annualYieldKwhPerKwp: 1124.2,
    monthlyShare: [0.041275, 0.055570, 0.089293, 0.108748, 0.110305, 0.113498, 0.117368, 0.108917, 0.094951, 0.072178, 0.048036, 0.039861],
    rank: 18,
  },
  {
    name: "Lahr",
    slug: "lahr",
    plz: "56288",
    bundesland: "Baden-Württemberg",
    population: 50775,
    annualYieldKwhPerKwp: 1122.2,
    monthlyShare: [0.040982, 0.055267, 0.088434, 0.107263, 0.110249, 0.116451, 0.118795, 0.111452, 0.099003, 0.071708, 0.044600, 0.035796],
    rank: 19,
  },
  {
    name: "Villingen-Schwenningen",
    slug: "villingen-schwenningen",
    plz: "78048",
    bundesland: "Baden-Württemberg",
    population: 81770,
    annualYieldKwhPerKwp: 1121,
    monthlyShare: [0.040578, 0.054922, 0.087776, 0.107186, 0.108266, 0.112289, 0.117944, 0.109934, 0.097195, 0.075171, 0.049534, 0.039205],
    rank: 20,
  },
  {
    name: "Straubing",
    slug: "straubing",
    plz: "94315",
    bundesland: "Bayern",
    population: 44580,
    annualYieldKwhPerKwp: 1120.8,
    monthlyShare: [0.034155, 0.053187, 0.088957, 0.116011, 0.116385, 0.119580, 0.122354, 0.113557, 0.095864, 0.070024, 0.039803, 0.030122],
    rank: 21,
  },
  {
    name: "Offenburg",
    slug: "offenburg",
    plz: "77652",
    bundesland: "Baden-Württemberg",
    population: 59238,
    annualYieldKwhPerKwp: 1120.1,
    monthlyShare: [0.038587, 0.054362, 0.088574, 0.109323, 0.113037, 0.118063, 0.119777, 0.111938, 0.098752, 0.069825, 0.044077, 0.033685],
    rank: 22,
  },
  {
    name: "Kaufbeuren",
    slug: "kaufbeuren",
    plz: "87600",
    bundesland: "Bayern",
    population: 42505,
    annualYieldKwhPerKwp: 1120.1,
    monthlyShare: [0.041166, 0.058093, 0.084367, 0.107882, 0.107882, 0.111623, 0.117221, 0.110953, 0.093893, 0.076198, 0.050602, 0.040121],
    rank: 23,
  },
  {
    name: "Speyer",
    slug: "speyer",
    plz: "67346",
    bundesland: "Rheinland-Pfalz",
    population: 50343,
    annualYieldKwhPerKwp: 1119.3,
    monthlyShare: [0.036746, 0.053631, 0.087750, 0.114329, 0.116831, 0.119073, 0.121637, 0.112659, 0.097346, 0.068632, 0.041132, 0.030233],
    rank: 24,
  },
  {
    name: "Kempten (Allgäu)",
    slug: "kempten-allgaeu",
    plz: "87435",
    bundesland: "Bayern",
    population: 61399,
    annualYieldKwhPerKwp: 1118.9,
    monthlyShare: [0.041282, 0.059819, 0.082314, 0.106347, 0.106008, 0.110628, 0.116491, 0.110030, 0.094988, 0.079428, 0.053187, 0.039477],
    rank: 25,
  },
  {
    name: "München",
    slug: "muenchen",
    plz: "80331",
    bundesland: "Bayern",
    population: 1505005,
    annualYieldKwhPerKwp: 1117.4,
    monthlyShare: [0.044272, 0.058851, 0.088044, 0.108278, 0.106900, 0.109451, 0.116422, 0.109853, 0.091919, 0.073456, 0.048792, 0.043762],
    rank: 26,
  },
  {
    name: "Sindelfingen",
    slug: "sindelfingen",
    plz: "71065",
    bundesland: "Baden-Württemberg",
    population: 61311,
    annualYieldKwhPerKwp: 1116.1,
    monthlyShare: [0.041788, 0.055855, 0.088531, 0.107652, 0.110429, 0.114748, 0.117534, 0.108816, 0.094848, 0.071893, 0.048033, 0.039871],
    rank: 27,
  },
  {
    name: "Fellbach",
    slug: "fellbach",
    plz: "70734",
    bundesland: "Baden-Württemberg",
    population: 43935,
    annualYieldKwhPerKwp: 1113.6,
    monthlyShare: [0.040698, 0.055740, 0.088680, 0.110151, 0.110546, 0.114444, 0.118206, 0.109172, 0.095585, 0.071168, 0.047110, 0.038498],
    rank: 28,
  },
  {
    name: "Landshut",
    slug: "landshut",
    plz: "84036",
    bundesland: "Bayern",
    population: 71863,
    annualYieldKwhPerKwp: 1113.3,
    monthlyShare: [0.036279, 0.052581, 0.086246, 0.114090, 0.114602, 0.116722, 0.121815, 0.114108, 0.094222, 0.072288, 0.042234, 0.034814],
    rank: 29,
  },
  {
    name: "Neu-Ulm",
    slug: "neu-ulm",
    plz: "89231",
    bundesland: "Bayern",
    population: 51389,
    annualYieldKwhPerKwp: 1113.2,
    monthlyShare: [0.037397, 0.053333, 0.089346, 0.112136, 0.113196, 0.116026, 0.121506, 0.113843, 0.096721, 0.069368, 0.041439, 0.035690],
    rank: 30,
  },
  {
    name: "Heilbronn",
    slug: "heilbronn",
    plz: "74072",
    bundesland: "Baden-Württemberg",
    population: 120733,
    annualYieldKwhPerKwp: 1113.1,
    monthlyShare: [0.038245, 0.052682, 0.086722, 0.112802, 0.115228, 0.117842, 0.120402, 0.112524, 0.096595, 0.069562, 0.043527, 0.033869],
    rank: 31,
  },
  {
    name: "Augsburg",
    slug: "augsburg",
    plz: "86152",
    bundesland: "Bayern",
    population: 301105,
    annualYieldKwhPerKwp: 1113,
    monthlyShare: [0.040657, 0.053740, 0.088368, 0.110723, 0.111415, 0.114074, 0.120795, 0.113292, 0.094172, 0.071440, 0.042526, 0.038797],
    rank: 32,
  },
  {
    name: "Waiblingen",
    slug: "waiblingen",
    plz: "71332",
    bundesland: "Baden-Württemberg",
    population: 52945,
    annualYieldKwhPerKwp: 1111.1,
    monthlyShare: [0.040645, 0.055505, 0.088832, 0.109344, 0.110505, 0.115068, 0.118641, 0.109938, 0.095061, 0.071120, 0.047179, 0.038161],
    rank: 33,
  },
  {
    name: "Ingolstadt",
    slug: "ingolstadt",
    plz: "85049",
    bundesland: "Bayern",
    population: 120658,
    annualYieldKwhPerKwp: 1110.5,
    monthlyShare: [0.035751, 0.051168, 0.088324, 0.114637, 0.116492, 0.118627, 0.123769, 0.115367, 0.094636, 0.069116, 0.039317, 0.032797],
    rank: 34,
  },
  {
    name: "Ulm",
    slug: "ulm",
    plz: "89073",
    bundesland: "Baden-Württemberg",
    population: 120451,
    annualYieldKwhPerKwp: 1109.5,
    monthlyShare: [0.037114, 0.052896, 0.089280, 0.112290, 0.114146, 0.117580, 0.121771, 0.113975, 0.097238, 0.068623, 0.040368, 0.034717],
    rank: 35,
  },
  {
    name: "Frankenthal",
    slug: "frankenthal",
    plz: "01909",
    bundesland: "Rheinland-Pfalz",
    population: 47438,
    annualYieldKwhPerKwp: 1108.1,
    monthlyShare: [0.036801, 0.054426, 0.088520, 0.115692, 0.116432, 0.118562, 0.121288, 0.112399, 0.096922, 0.069172, 0.039987, 0.029798],
    rank: 36,
  },
  {
    name: "Leonberg",
    slug: "leonberg",
    plz: "71229",
    bundesland: "Baden-Württemberg",
    population: 49480,
    annualYieldKwhPerKwp: 1108,
    monthlyShare: [0.042193, 0.056037, 0.088898, 0.107589, 0.110838, 0.114746, 0.117201, 0.108699, 0.094656, 0.071425, 0.047463, 0.040252],
    rank: 37,
  },
  {
    name: "Ludwigshafen am Rhein",
    slug: "ludwigshafen-am-rhein",
    plz: "67059",
    bundesland: "Rheinland-Pfalz",
    population: 163196,
    annualYieldKwhPerKwp: 1106.6,
    monthlyShare: [0.035586, 0.054184, 0.088135, 0.115579, 0.116808, 0.119013, 0.121525, 0.113040, 0.097542, 0.069031, 0.040060, 0.029496],
    rank: 38,
  },
  {
    name: "Rosenheim",
    slug: "rosenheim",
    plz: "83022",
    bundesland: "Bayern",
    population: 60167,
    annualYieldKwhPerKwp: 1105.9,
    monthlyShare: [0.044616, 0.057303, 0.088238, 0.108250, 0.106170, 0.108467, 0.116053, 0.109452, 0.091882, 0.074719, 0.050322, 0.044526],
    rank: 39,
  },
  {
    name: "Neustadt an der Weinstraße",
    slug: "neustadt-an-der-weinstrasse",
    plz: "67434",
    bundesland: "Rheinland-Pfalz",
    population: 53984,
    annualYieldKwhPerKwp: 1105.4,
    monthlyShare: [0.035093, 0.054680, 0.091139, 0.116379, 0.116958, 0.119673, 0.121862, 0.111829, 0.097716, 0.068096, 0.038856, 0.027720],
    rank: 40,
  },
  {
    name: "Mainz",
    slug: "mainz",
    plz: "55130",
    bundesland: "Rheinland-Pfalz",
    population: 222889,
    annualYieldKwhPerKwp: 1102.7,
    monthlyShare: [0.035586, 0.052282, 0.090272, 0.117932, 0.120317, 0.120607, 0.122212, 0.112373, 0.096838, 0.066910, 0.036756, 0.027914],
    rank: 41,
  },
  {
    name: "Regensburg",
    slug: "regensburg",
    plz: "93047",
    bundesland: "Bayern",
    population: 151389,
    annualYieldKwhPerKwp: 1102.7,
    monthlyShare: [0.034734, 0.053624, 0.089728, 0.115937, 0.117079, 0.118848, 0.121832, 0.113706, 0.096203, 0.069450, 0.038951, 0.029909],
    rank: 42,
  },
  {
    name: "Würzburg",
    slug: "wuerzburg",
    plz: "97074",
    bundesland: "Bayern",
    population: 133731,
    annualYieldKwhPerKwp: 1102.2,
    monthlyShare: [0.034177, 0.052041, 0.086399, 0.115976, 0.120313, 0.121166, 0.122472, 0.113372, 0.097676, 0.068834, 0.038777, 0.028797],
    rank: 43,
  },
  {
    name: "Worms",
    slug: "worms",
    plz: "67547",
    bundesland: "Rheinland-Pfalz",
    population: 81099,
    annualYieldKwhPerKwp: 1100.3,
    monthlyShare: [0.036499, 0.054739, 0.089320, 0.116076, 0.117112, 0.119494, 0.121129, 0.111578, 0.097073, 0.068853, 0.038835, 0.029292],
    rank: 44,
  },
  {
    name: "Göppingen",
    slug: "goeppingen",
    plz: "73033",
    bundesland: "Baden-Württemberg",
    population: 58040,
    annualYieldKwhPerKwp: 1099.9,
    monthlyShare: [0.038022, 0.053432, 0.086335, 0.108610, 0.110783, 0.114874, 0.121493, 0.112519, 0.095672, 0.071907, 0.048423, 0.037931],
    rank: 45,
  },
  {
    name: "Reutlingen",
    slug: "reutlingen",
    plz: "72764",
    bundesland: "Baden-Württemberg",
    population: 112627,
    annualYieldKwhPerKwp: 1098.2,
    monthlyShare: [0.039673, 0.054988, 0.087022, 0.105971, 0.109758, 0.114193, 0.119693, 0.111907, 0.096610, 0.072972, 0.047740, 0.039473],
    rank: 46,
  },
  {
    name: "Mannheim",
    slug: "mannheim",
    plz: "68163",
    bundesland: "Baden-Württemberg",
    population: 307960,
    annualYieldKwhPerKwp: 1097.3,
    monthlyShare: [0.035987, 0.054013, 0.087923, 0.115426, 0.117057, 0.119609, 0.121869, 0.112901, 0.097455, 0.068430, 0.040015, 0.029317],
    rank: 47,
  },
  {
    name: "Passau",
    slug: "passau",
    plz: "94036",
    bundesland: "Bayern",
    population: 50560,
    annualYieldKwhPerKwp: 1093.9,
    monthlyShare: [0.037699, 0.058303, 0.088104, 0.113397, 0.113452, 0.116405, 0.120884, 0.113982, 0.094091, 0.070653, 0.040039, 0.032991],
    rank: 48,
  },
  {
    name: "Bad Kreuznach",
    slug: "bad-kreuznach",
    plz: "55543",
    bundesland: "Rheinland-Pfalz",
    population: 43213,
    annualYieldKwhPerKwp: 1092.6,
    monthlyShare: [0.034751, 0.050996, 0.087871, 0.117972, 0.119940, 0.120416, 0.123702, 0.113616, 0.096318, 0.067315, 0.037506, 0.029598],
    rank: 49,
  },
  {
    name: "Oberursel",
    slug: "oberursel",
    plz: "61440",
    bundesland: "Hessen",
    population: 46736,
    annualYieldKwhPerKwp: 1091.1,
    monthlyShare: [0.035607, 0.052544, 0.088976, 0.117874, 0.120138, 0.121247, 0.123511, 0.113099, 0.096941, 0.066750, 0.036606, 0.026707],
    rank: 50,
  },
  {
    name: "Rüsselsheim am Main",
    slug: "ruesselsheim-am-main",
    plz: "65428",
    bundesland: "Hessen",
    population: 59730,
    annualYieldKwhPerKwp: 1090.7,
    monthlyShare: [0.034629, 0.052224, 0.089806, 0.117439, 0.120896, 0.121336, 0.122941, 0.113094, 0.097305, 0.066930, 0.036674, 0.026726],
    rank: 51,
  },
  {
    name: "Fürth",
    slug: "fuerth",
    plz: "90762",
    bundesland: "Bayern",
    population: 132036,
    annualYieldKwhPerKwp: 1090.5,
    monthlyShare: [0.035891, 0.053516, 0.085923, 0.114424, 0.117404, 0.117321, 0.121319, 0.112470, 0.096909, 0.071673, 0.041192, 0.031958],
    rank: 52,
  },
  {
    name: "Schwäbisch Gmünd",
    slug: "schwaebisch-gmuend",
    plz: "73525",
    bundesland: "Baden-Württemberg",
    population: 61216,
    annualYieldKwhPerKwp: 1089.8,
    monthlyShare: [0.035731, 0.053403, 0.085427, 0.110018, 0.112211, 0.116405, 0.122488, 0.113312, 0.095842, 0.071287, 0.046898, 0.036979],
    rank: 53,
  },
  {
    name: "Saarbrücken",
    slug: "saarbruecken",
    plz: "66121",
    bundesland: "Saarland",
    population: 182971,
    annualYieldKwhPerKwp: 1086,
    monthlyShare: [0.035323, 0.051953, 0.088492, 0.114846, 0.117783, 0.120951, 0.124514, 0.112470, 0.098418, 0.068049, 0.038085, 0.029117],
    rank: 54,
  },
  {
    name: "Bad Homburg vor der Höhe",
    slug: "bad-homburg-vor-der-hoehe",
    plz: "61348",
    bundesland: "Hessen",
    population: 51859,
    annualYieldKwhPerKwp: 1084.5,
    monthlyShare: [0.036356, 0.053193, 0.089097, 0.117754, 0.119718, 0.120557, 0.123157, 0.112738, 0.096630, 0.066866, 0.036817, 0.027117],
    rank: 55,
  },
  {
    name: "Schweinfurt",
    slug: "schweinfurt",
    plz: "97421",
    bundesland: "Bayern",
    population: 54012,
    annualYieldKwhPerKwp: 1084.1,
    monthlyShare: [0.034517, 0.051628, 0.086680, 0.117886, 0.121271, 0.120948, 0.124315, 0.113311, 0.096928, 0.067586, 0.036141, 0.028789],
    rank: 56,
  },
  {
    name: "Wiesbaden",
    slug: "wiesbaden",
    plz: "65193",
    bundesland: "Hessen",
    population: 288850,
    annualYieldKwhPerKwp: 1082.5,
    monthlyShare: [0.036111, 0.052388, 0.089858, 0.117498, 0.119918, 0.120066, 0.123410, 0.113294, 0.096999, 0.066652, 0.036028, 0.027779],
    rank: 57,
  },
  {
    name: "Erkelenz",
    slug: "erkelenz",
    plz: "41812",
    bundesland: "Nordrhein-Westfalen",
    population: 44650,
    annualYieldKwhPerKwp: 1080.9,
    monthlyShare: [0.036691, 0.052002, 0.086113, 0.115227, 0.121981, 0.119705, 0.120158, 0.110324, 0.095438, 0.069738, 0.042566, 0.030058],
    rank: 58,
  },
  {
    name: "Düren",
    slug: "dueren",
    plz: "52351",
    bundesland: "Nordrhein-Westfalen",
    population: 93440,
    annualYieldKwhPerKwp: 1080.6,
    monthlyShare: [0.038913, 0.055274, 0.086950, 0.112149, 0.117507, 0.116776, 0.118895, 0.107910, 0.094501, 0.071255, 0.045964, 0.033906],
    rank: 59,
  },
  {
    name: "Hanau am Main",
    slug: "hanau-am-main",
    plz: "63405",
    bundesland: "Hessen",
    population: 88648,
    annualYieldKwhPerKwp: 1078.9,
    monthlyShare: [0.036409, 0.052834, 0.087705, 0.116541, 0.118404, 0.119683, 0.123743, 0.113714, 0.097335, 0.067767, 0.037800, 0.028067],
    rank: 60,
  },
  {
    name: "Offenbach",
    slug: "offenbach",
    plz: "63073",
    bundesland: "Hessen",
    population: 119192,
    annualYieldKwhPerKwp: 1078.7,
    monthlyShare: [0.036340, 0.053825, 0.087782, 0.116549, 0.118903, 0.119840, 0.123363, 0.113397, 0.096747, 0.067332, 0.037332, 0.028590],
    rank: 61,
  },
  {
    name: "Frankfurt am Main",
    slug: "frankfurt-am-main",
    plz: "60313",
    bundesland: "Hessen",
    population: 650000,
    annualYieldKwhPerKwp: 1078.6,
    monthlyShare: [0.036678, 0.053951, 0.088015, 0.116135, 0.119454, 0.120131, 0.123692, 0.112825, 0.097036, 0.066866, 0.037068, 0.028148],
    rank: 62,
  },
  {
    name: "Nürnberg",
    slug: "nuernberg",
    plz: "90403",
    bundesland: "Bayern",
    population: 515543,
    annualYieldKwhPerKwp: 1078,
    monthlyShare: [0.037588, 0.055167, 0.086030, 0.113868, 0.116874, 0.116800, 0.120909, 0.112059, 0.096289, 0.071095, 0.041020, 0.032301],
    rank: 63,
  },
  {
    name: "Baden-Baden",
    slug: "baden-baden",
    plz: "76530",
    bundesland: "Baden-Württemberg",
    population: 56881,
    annualYieldKwhPerKwp: 1078,
    monthlyShare: [0.040138, 0.052763, 0.088142, 0.109552, 0.112307, 0.117242, 0.118865, 0.112158, 0.096333, 0.071278, 0.045824, 0.035398],
    rank: 64,
  },
  {
    name: "Albstadt",
    slug: "albstadt",
    plz: "72458",
    bundesland: "Baden-Württemberg",
    population: 46950,
    annualYieldKwhPerKwp: 1077.9,
    monthlyShare: [0.037043, 0.055662, 0.087825, 0.108141, 0.110470, 0.115368, 0.120693, 0.112594, 0.095144, 0.073371, 0.046162, 0.037525],
    rank: 65,
  },
  {
    name: "Heidenheim an der Brenz",
    slug: "heidenheim-an-der-brenz",
    plz: "89522",
    bundesland: "Baden-Württemberg",
    population: 50067,
    annualYieldKwhPerKwp: 1077.7,
    monthlyShare: [0.033879, 0.051138, 0.089861, 0.114775, 0.116585, 0.118645, 0.124277, 0.115917, 0.097432, 0.068045, 0.037730, 0.031717],
    rank: 66,
  },
  {
    name: "Euskirchen",
    slug: "euskirchen",
    plz: "53879",
    bundesland: "Nordrhein-Westfalen",
    population: 54889,
    annualYieldKwhPerKwp: 1077.2,
    monthlyShare: [0.038545, 0.054884, 0.087181, 0.112581, 0.117715, 0.117028, 0.118699, 0.109044, 0.094385, 0.070304, 0.045860, 0.033773],
    rank: 67,
  },
  {
    name: "Erftstadt",
    slug: "erftstadt",
    plz: "50374",
    bundesland: "Nordrhein-Westfalen",
    population: 51207,
    annualYieldKwhPerKwp: 1077.2,
    monthlyShare: [0.038229, 0.054494, 0.087320, 0.113397, 0.119580, 0.118187, 0.118252, 0.109117, 0.094932, 0.070526, 0.044180, 0.031786],
    rank: 68,
  },
  {
    name: "Homburg",
    slug: "homburg",
    plz: "66424",
    bundesland: "Saarland",
    population: 44607,
    annualYieldKwhPerKwp: 1076.8,
    monthlyShare: [0.034529, 0.050187, 0.087892, 0.115994, 0.118371, 0.122003, 0.124454, 0.113579, 0.098507, 0.068603, 0.037696, 0.028186],
    rank: 69,
  },
  {
    name: "Kerpen",
    slug: "kerpen",
    plz: "50171",
    bundesland: "Nordrhein-Westfalen",
    population: 64226,
    annualYieldKwhPerKwp: 1076.1,
    monthlyShare: [0.037487, 0.053517, 0.086934, 0.114571, 0.120258, 0.119087, 0.119413, 0.109274, 0.094750, 0.070412, 0.043332, 0.030964],
    rank: 70,
  },
  {
    name: "Halle (Saale)",
    slug: "halle-saale",
    plz: "06108",
    bundesland: "Sachsen-Anhalt",
    population: 237865,
    annualYieldKwhPerKwp: 1075.8,
    monthlyShare: [0.035519, 0.051768, 0.083336, 0.115350, 0.123437, 0.121457, 0.120556, 0.112552, 0.094500, 0.067691, 0.041412, 0.032423],
    rank: 71,
  },
  {
    name: "Görlitz",
    slug: "goerlitz",
    plz: "02826",
    bundesland: "Sachsen",
    population: 57751,
    annualYieldKwhPerKwp: 1073.2,
    monthlyShare: [0.032818, 0.051640, 0.083377, 0.116213, 0.120695, 0.119186, 0.121068, 0.114266, 0.094251, 0.071664, 0.042220, 0.032603],
    rank: 72,
  },
  {
    name: "Rodgau",
    slug: "rodgau",
    plz: "63110",
    bundesland: "Hessen",
    population: 43315,
    annualYieldKwhPerKwp: 1073.2,
    monthlyShare: [0.036938, 0.052900, 0.087685, 0.116106, 0.118305, 0.119768, 0.123607, 0.113767, 0.097152, 0.067753, 0.037963, 0.028057],
    rank: 73,
  },
  {
    name: "Aalen",
    slug: "aalen",
    plz: "73430",
    bundesland: "Baden-Württemberg",
    population: 67085,
    annualYieldKwhPerKwp: 1070.4,
    monthlyShare: [0.037894, 0.055374, 0.087279, 0.110253, 0.113719, 0.116615, 0.123080, 0.113354, 0.094323, 0.069584, 0.043490, 0.035035],
    rank: 74,
  },
  {
    name: "Darmstadt",
    slug: "darmstadt",
    plz: "64283",
    bundesland: "Hessen",
    population: 167029,
    annualYieldKwhPerKwp: 1069.4,
    monthlyShare: [0.035676, 0.052434, 0.086501, 0.117118, 0.119531, 0.121373, 0.122654, 0.112807, 0.097592, 0.068238, 0.038313, 0.027765],
    rank: 75,
  },
  {
    name: "Magdeburg",
    slug: "magdeburg",
    plz: "39104",
    bundesland: "Sachsen-Anhalt",
    population: 244329,
    annualYieldKwhPerKwp: 1069.1,
    monthlyShare: [0.032120, 0.050611, 0.083900, 0.117179, 0.123661, 0.124643, 0.122417, 0.113466, 0.095760, 0.068392, 0.038312, 0.029538],
    rank: 76,
  },
  {
    name: "Neunkirchen",
    slug: "neunkirchen",
    plz: "54426",
    bundesland: "Saarland",
    population: 49843,
    annualYieldKwhPerKwp: 1067.4,
    monthlyShare: [0.035330, 0.050751, 0.088077, 0.115500, 0.118048, 0.121749, 0.125403, 0.113664, 0.098411, 0.067634, 0.036764, 0.028669],
    rank: 77,
  },
  {
    name: "Heidelberg",
    slug: "heidelberg",
    plz: "69117",
    bundesland: "Baden-Württemberg",
    population: 143345,
    annualYieldKwhPerKwp: 1067.2,
    monthlyShare: [0.034773, 0.051742, 0.086571, 0.116696, 0.119460, 0.121465, 0.123405, 0.114662, 0.098124, 0.067465, 0.038155, 0.027483],
    rank: 78,
  },
  {
    name: "Cottbus",
    slug: "cottbus",
    plz: "03046",
    bundesland: "Brandenburg",
    population: 84754,
    annualYieldKwhPerKwp: 1067.2,
    monthlyShare: [0.032908, 0.052679, 0.082532, 0.117923, 0.121540, 0.120734, 0.121343, 0.114859, 0.096006, 0.069161, 0.040057, 0.030256],
    rank: 79,
  },
  {
    name: "Mönchengladbach",
    slug: "moenchengladbach",
    plz: "41065",
    bundesland: "Nordrhein-Westfalen",
    population: 261742,
    annualYieldKwhPerKwp: 1066.8,
    monthlyShare: [0.037262, 0.052335, 0.085922, 0.114466, 0.121609, 0.120297, 0.120737, 0.110641, 0.094640, 0.069171, 0.042680, 0.030241],
    rank: 80,
  },
  {
    name: "Pforzheim",
    slug: "pforzheim",
    plz: "75173",
    bundesland: "Baden-Württemberg",
    population: 119313,
    annualYieldKwhPerKwp: 1066.7,
    monthlyShare: [0.036244, 0.052847, 0.089981, 0.111365, 0.113737, 0.117318, 0.121256, 0.112903, 0.095859, 0.069975, 0.043378, 0.035137],
    rank: 81,
  },
  {
    name: "Leipzig",
    slug: "leipzig",
    plz: "04109",
    bundesland: "Sachsen",
    population: 504971,
    annualYieldKwhPerKwp: 1066.5,
    monthlyShare: [0.034731, 0.051515, 0.082607, 0.115941, 0.122983, 0.121417, 0.121764, 0.111994, 0.094506, 0.067989, 0.041604, 0.032949],
    rank: 82,
  },
  {
    name: "Pirmasens",
    slug: "pirmasens",
    plz: "66954",
    bundesland: "Rheinland-Pfalz",
    population: 43582,
    annualYieldKwhPerKwp: 1065.5,
    monthlyShare: [0.036686, 0.052603, 0.088698, 0.113607, 0.116366, 0.119998, 0.123123, 0.112752, 0.097483, 0.069234, 0.039051, 0.030398],
    rank: 83,
  },
  {
    name: "Dresden",
    slug: "dresden",
    plz: "01069",
    bundesland: "Sachsen",
    population: 564904,
    annualYieldKwhPerKwp: 1064.8,
    monthlyShare: [0.034730, 0.053898, 0.084533, 0.113891, 0.119263, 0.117169, 0.121930, 0.111693, 0.093511, 0.070493, 0.044074, 0.034814],
    rank: 84,
  },
  {
    name: "Wetzlar",
    slug: "wetzlar",
    plz: "35579",
    bundesland: "Hessen",
    population: 52656,
    annualYieldKwhPerKwp: 1064.1,
    monthlyShare: [0.033917, 0.051913, 0.088349, 0.116533, 0.119991, 0.123233, 0.125432, 0.115123, 0.096309, 0.067777, 0.035646, 0.025778],
    rank: 85,
  },
  {
    name: "Nordhausen",
    slug: "nordhausen",
    plz: "99734",
    bundesland: "Thüringen",
    population: 43912,
    annualYieldKwhPerKwp: 1063,
    monthlyShare: [0.031400, 0.048812, 0.087089, 0.119110, 0.124322, 0.123259, 0.124491, 0.113287, 0.097145, 0.066714, 0.037223, 0.027148],
    rank: 86,
  },
  {
    name: "Amberg",
    slug: "amberg",
    plz: "92224",
    bundesland: "Bayern",
    population: 44737,
    annualYieldKwhPerKwp: 1061.5,
    monthlyShare: [0.035685, 0.054912, 0.087601, 0.116022, 0.117624, 0.118622, 0.122325, 0.113366, 0.096908, 0.068929, 0.037409, 0.030598],
    rank: 87,
  },
  {
    name: "Erlangen",
    slug: "erlangen",
    plz: "91052",
    bundesland: "Bayern",
    population: 102675,
    annualYieldKwhPerKwp: 1061.3,
    monthlyShare: [0.036484, 0.053586, 0.084963, 0.114926, 0.118365, 0.117857, 0.122775, 0.113315, 0.097080, 0.070490, 0.039998, 0.030161],
    rank: 88,
  },
  {
    name: "Zwickau",
    slug: "zwickau",
    plz: "08056",
    bundesland: "Sachsen",
    population: 98796,
    annualYieldKwhPerKwp: 1061,
    monthlyShare: [0.035449, 0.052056, 0.082726, 0.113368, 0.118882, 0.117826, 0.121276, 0.111558, 0.093273, 0.071180, 0.045788, 0.036617],
    rank: 89,
  },
  {
    name: "Bamberg",
    slug: "bamberg",
    plz: "96047",
    bundesland: "Bayern",
    population: 70047,
    annualYieldKwhPerKwp: 1061,
    monthlyShare: [0.035881, 0.051913, 0.085146, 0.116070, 0.120245, 0.120679, 0.124185, 0.113845, 0.097408, 0.068200, 0.037851, 0.028577],
    rank: 90,
  },
  {
    name: "Dessau",
    slug: "dessau",
    plz: "06844",
    bundesland: "Sachsen-Anhalt",
    population: 67747,
    annualYieldKwhPerKwp: 1060.3,
    monthlyShare: [0.032604, 0.051023, 0.083051, 0.116617, 0.123690, 0.122804, 0.122162, 0.113316, 0.096170, 0.068508, 0.039696, 0.030359],
    rank: 91,
  },
  {
    name: "Gießen",
    slug: "giessen",
    plz: "35390",
    bundesland: "Hessen",
    population: 89179,
    annualYieldKwhPerKwp: 1060.1,
    monthlyShare: [0.035741, 0.052221, 0.089169, 0.117006, 0.119270, 0.122562, 0.123977, 0.114515, 0.096593, 0.066728, 0.035609, 0.026610],
    rank: 92,
  },
  {
    name: "Gera",
    slug: "gera",
    plz: "07545",
    bundesland: "Thüringen",
    population: 104659,
    annualYieldKwhPerKwp: 1060,
    monthlyShare: [0.034691, 0.049899, 0.083212, 0.114874, 0.121384, 0.119129, 0.122696, 0.112431, 0.093949, 0.069834, 0.043408, 0.034493],
    rank: 93,
  },
  {
    name: "Frankfurt (Oder)",
    slug: "frankfurt-oder",
    plz: "15236",
    bundesland: "Brandenburg",
    population: 57107,
    annualYieldKwhPerKwp: 1056.9,
    monthlyShare: [0.031725, 0.051425, 0.082971, 0.119370, 0.122739, 0.122701, 0.123779, 0.117241, 0.097778, 0.066412, 0.036882, 0.026976],
    rank: 94,
  },
  {
    name: "Brühl",
    slug: "bruehl",
    plz: "50321",
    bundesland: "Nordrhein-Westfalen",
    population: 44137,
    annualYieldKwhPerKwp: 1056.7,
    monthlyShare: [0.038119, 0.053904, 0.087216, 0.113761, 0.119060, 0.118975, 0.119335, 0.110430, 0.094597, 0.069377, 0.043267, 0.031958],
    rank: 95,
  },
  {
    name: "Trier",
    slug: "trier",
    plz: "54290",
    bundesland: "Rheinland-Pfalz",
    population: 100129,
    annualYieldKwhPerKwp: 1055.8,
    monthlyShare: [0.034609, 0.049603, 0.087385, 0.116785, 0.119853, 0.121994, 0.124741, 0.113005, 0.099556, 0.066737, 0.036077, 0.029656],
    rank: 96,
  },
  {
    name: "Kaiserslautern",
    slug: "kaiserslautern",
    plz: "67655",
    bundesland: "Rheinland-Pfalz",
    population: 98732,
    annualYieldKwhPerKwp: 1055.5,
    monthlyShare: [0.036379, 0.052466, 0.087263, 0.114528, 0.117152, 0.120430, 0.124324, 0.112491, 0.096585, 0.068542, 0.039079, 0.030761],
    rank: 97,
  },
  {
    name: "Berlin",
    slug: "berlin",
    plz: "10178",
    bundesland: "Berlin",
    population: 3426354,
    annualYieldKwhPerKwp: 1054.8,
    monthlyShare: [0.031495, 0.052315, 0.083601, 0.118234, 0.123534, 0.125004, 0.122709, 0.116063, 0.097301, 0.065891, 0.036397, 0.027456],
    rank: 98,
  },
  {
    name: "Nettetal",
    slug: "nettetal",
    plz: "41334",
    bundesland: "Nordrhein-Westfalen",
    population: 42417,
    annualYieldKwhPerKwp: 1054.8,
    monthlyShare: [0.036378, 0.050912, 0.085450, 0.114973, 0.123051, 0.121259, 0.121837, 0.111001, 0.094931, 0.068773, 0.042094, 0.029343],
    rank: 99,
  },
  {
    name: "Krefeld",
    slug: "krefeld",
    plz: "47798",
    bundesland: "Nordrhein-Westfalen",
    population: 237984,
    annualYieldKwhPerKwp: 1054.4,
    monthlyShare: [0.035461, 0.051044, 0.086012, 0.114322, 0.121995, 0.120354, 0.122516, 0.111923, 0.094604, 0.069699, 0.042356, 0.029714],
    rank: 100,
  },
  {
    name: "Freiburg",
    slug: "freiburg",
    plz: "79102",
    bundesland: "Baden-Württemberg",
    population: 237460,
    annualYieldKwhPerKwp: 1054.4,
    monthlyShare: [0.042535, 0.058070, 0.087735, 0.105176, 0.104636, 0.111919, 0.117999, 0.111938, 0.095835, 0.076933, 0.048690, 0.038533],
    rank: 101,
  },
  {
    name: "Brandenburg an der Havel",
    slug: "brandenburg-an-der-havel",
    plz: "14776",
    bundesland: "Brandenburg",
    population: 59826,
    annualYieldKwhPerKwp: 1054.4,
    monthlyShare: [0.031933, 0.051603, 0.082541, 0.118182, 0.123512, 0.123085, 0.123427, 0.116171, 0.097943, 0.066399, 0.038050, 0.027153],
    rank: 102,
  },
  {
    name: "Willich",
    slug: "willich",
    plz: "47877",
    bundesland: "Nordrhein-Westfalen",
    population: 51843,
    annualYieldKwhPerKwp: 1053.8,
    monthlyShare: [0.035786, 0.051539, 0.086186, 0.114133, 0.122076, 0.120263, 0.122123, 0.111542, 0.094385, 0.069655, 0.042210, 0.030101],
    rank: 103,
  },
  {
    name: "Bergheim",
    slug: "bergheim",
    plz: "50126",
    bundesland: "Nordrhein-Westfalen",
    population: 63558,
    annualYieldKwhPerKwp: 1053.5,
    monthlyShare: [0.037855, 0.052692, 0.086693, 0.114581, 0.120732, 0.119669, 0.120267, 0.110034, 0.094163, 0.069512, 0.043095, 0.030707],
    rank: 104,
  },
  {
    name: "Viersen",
    slug: "viersen",
    plz: "41747",
    bundesland: "Nordrhein-Westfalen",
    population: 76153,
    annualYieldKwhPerKwp: 1053.3,
    monthlyShare: [0.036295, 0.051760, 0.085947, 0.114087, 0.121805, 0.120752, 0.122176, 0.111125, 0.094786, 0.068820, 0.042485, 0.029962],
    rank: 105,
  },
  {
    name: "Potsdam",
    slug: "potsdam",
    plz: "14461",
    bundesland: "Brandenburg",
    population: 184754,
    annualYieldKwhPerKwp: 1053,
    monthlyShare: [0.031681, 0.052688, 0.082137, 0.118072, 0.122887, 0.123808, 0.122773, 0.116040, 0.097806, 0.067037, 0.037787, 0.027284],
    rank: 106,
  },
  {
    name: "Weiden",
    slug: "weiden",
    plz: "92637",
    bundesland: "Bayern",
    population: 42550,
    annualYieldKwhPerKwp: 1052.9,
    monthlyShare: [0.033176, 0.052457, 0.086212, 0.117374, 0.119673, 0.119777, 0.123463, 0.114402, 0.097220, 0.070294, 0.037934, 0.028019],
    rank: 107,
  },
  {
    name: "Alsdorf",
    slug: "alsdorf",
    plz: "52477",
    bundesland: "Nordrhein-Westfalen",
    population: 46340,
    annualYieldKwhPerKwp: 1052,
    monthlyShare: [0.037358, 0.051988, 0.083975, 0.113215, 0.119527, 0.118909, 0.120867, 0.110107, 0.095924, 0.070581, 0.045334, 0.032215],
    rank: 108,
  },
  {
    name: "Herzogenrath",
    slug: "herzogenrath",
    plz: "52134",
    bundesland: "Nordrhein-Westfalen",
    population: 47381,
    annualYieldKwhPerKwp: 1051.8,
    monthlyShare: [0.037499, 0.052598, 0.084392, 0.112773, 0.119571, 0.119124, 0.120522, 0.109930, 0.095877, 0.070358, 0.045219, 0.032137],
    rank: 109,
  },
  {
    name: "Weimar",
    slug: "weimar",
    plz: "99423",
    bundesland: "Thüringen",
    population: 64727,
    annualYieldKwhPerKwp: 1050.5,
    monthlyShare: [0.035477, 0.050613, 0.085128, 0.114580, 0.119987, 0.119882, 0.123357, 0.112438, 0.094486, 0.068051, 0.042959, 0.033040],
    rank: 110,
  },
  {
    name: "Pulheim",
    slug: "pulheim",
    plz: "50259",
    bundesland: "Nordrhein-Westfalen",
    population: 53762,
    annualYieldKwhPerKwp: 1050.5,
    monthlyShare: [0.038143, 0.052660, 0.087033, 0.113268, 0.120931, 0.119931, 0.120464, 0.110441, 0.093944, 0.068956, 0.042636, 0.031594],
    rank: 111,
  },
  {
    name: "Jena",
    slug: "jena",
    plz: "07743",
    bundesland: "Thüringen",
    population: 104712,
    annualYieldKwhPerKwp: 1050.3,
    monthlyShare: [0.037550, 0.053088, 0.086240, 0.114174, 0.119953, 0.118753, 0.121238, 0.110832, 0.093704, 0.067922, 0.042787, 0.033761],
    rank: 112,
  },
  {
    name: "Grevenbroich",
    slug: "grevenbroich",
    plz: "41517",
    bundesland: "Nordrhein-Westfalen",
    population: 64779,
    annualYieldKwhPerKwp: 1050.2,
    monthlyShare: [0.035993, 0.051914, 0.086584, 0.114911, 0.121758, 0.120834, 0.121072, 0.111084, 0.094620, 0.069168, 0.042440, 0.029623],
    rank: 113,
  },
  {
    name: "Neuss",
    slug: "neuss",
    plz: "41470",
    bundesland: "Nordrhein-Westfalen",
    population: 152457,
    annualYieldKwhPerKwp: 1048.8,
    monthlyShare: [0.035945, 0.052459, 0.087022, 0.114491, 0.122442, 0.120898, 0.121203, 0.110839, 0.094659, 0.068877, 0.041647, 0.029519],
    rank: 114,
  },
  {
    name: "Kaarst",
    slug: "kaarst",
    plz: "41564",
    bundesland: "Nordrhein-Westfalen",
    population: 42112,
    annualYieldKwhPerKwp: 1048.2,
    monthlyShare: [0.035689, 0.052164, 0.086899, 0.114450, 0.122149, 0.120756, 0.121576, 0.111579, 0.094273, 0.068649, 0.041947, 0.029869],
    rank: 115,
  },
  {
    name: "Köln",
    slug: "koeln",
    plz: "50676",
    bundesland: "Nordrhein-Westfalen",
    population: 1024621,
    annualYieldKwhPerKwp: 1046.5,
    monthlyShare: [0.038251, 0.053330, 0.087434, 0.113731, 0.120105, 0.119121, 0.120382, 0.110081, 0.094553, 0.068791, 0.042666, 0.031553],
    rank: 116,
  },
  {
    name: "Salzgitter",
    slug: "salzgitter",
    plz: "38226",
    bundesland: "Niedersachsen",
    population: 104970,
    annualYieldKwhPerKwp: 1045.5,
    monthlyShare: [0.031161, 0.049592, 0.084302, 0.117596, 0.123985, 0.124817, 0.123813, 0.113894, 0.096850, 0.068252, 0.037436, 0.028301],
    rank: 117,
  },
  {
    name: "Aschaffenburg",
    slug: "aschaffenburg",
    plz: "63739",
    bundesland: "Bayern",
    population: 68551,
    annualYieldKwhPerKwp: 1045.5,
    monthlyShare: [0.035235, 0.052126, 0.086109, 0.116131, 0.119718, 0.119613, 0.124596, 0.114563, 0.096974, 0.068338, 0.038832, 0.027766],
    rank: 118,
  },
  {
    name: "Neuwied",
    slug: "neuwied",
    plz: "56564",
    bundesland: "Rheinland-Pfalz",
    population: 66805,
    annualYieldKwhPerKwp: 1045.2,
    monthlyShare: [0.033621, 0.052929, 0.088875, 0.119588, 0.120803, 0.121444, 0.123377, 0.112843, 0.096587, 0.066745, 0.035678, 0.027507],
    rank: 119,
  },
  {
    name: "Gotha",
    slug: "gotha",
    plz: "99867",
    bundesland: "Thüringen",
    population: 46615,
    annualYieldKwhPerKwp: 1043.8,
    monthlyShare: [0.034451, 0.049530, 0.086405, 0.116515, 0.118863, 0.119140, 0.123404, 0.113775, 0.095372, 0.068125, 0.042795, 0.031625],
    rank: 120,
  },
  {
    name: "Lippstadt",
    slug: "lippstadt",
    plz: "59555",
    bundesland: "Nordrhein-Westfalen",
    population: 67219,
    annualYieldKwhPerKwp: 1043.6,
    monthlyShare: [0.032827, 0.051867, 0.086486, 0.114455, 0.122494, 0.122322, 0.120789, 0.112615, 0.094525, 0.070283, 0.041624, 0.029713],
    rank: 121,
  },
  {
    name: "Bayreuth",
    slug: "bayreuth",
    plz: "95447",
    bundesland: "Bayern",
    population: 72940,
    annualYieldKwhPerKwp: 1042.7,
    monthlyShare: [0.032656, 0.052039, 0.084388, 0.117092, 0.120459, 0.121169, 0.125235, 0.114561, 0.098113, 0.069082, 0.037615, 0.027592],
    rank: 122,
  },
  {
    name: "Hamm",
    slug: "hamm",
    plz: "59065",
    bundesland: "Nordrhein-Westfalen",
    population: 178967,
    annualYieldKwhPerKwp: 1042.6,
    monthlyShare: [0.032938, 0.051546, 0.086901, 0.115062, 0.123896, 0.121392, 0.121939, 0.112175, 0.094066, 0.069012, 0.041916, 0.029159],
    rank: 123,
  },
  {
    name: "Frechen",
    slug: "frechen",
    plz: "50226",
    bundesland: "Nordrhein-Westfalen",
    population: 52309,
    annualYieldKwhPerKwp: 1042.1,
    monthlyShare: [0.038135, 0.052741, 0.086942, 0.113830, 0.120634, 0.119751, 0.120442, 0.110423, 0.094158, 0.068997, 0.042799, 0.031149],
    rank: 124,
  },
  {
    name: "Bornheim",
    slug: "bornheim",
    plz: "53332",
    bundesland: "Nordrhein-Westfalen",
    population: 48523,
    annualYieldKwhPerKwp: 1041.8,
    monthlyShare: [0.038511, 0.054388, 0.087159, 0.113787, 0.118356, 0.118750, 0.119518, 0.110552, 0.094762, 0.069526, 0.042591, 0.032099],
    rank: 125,
  },
  {
    name: "Freiberg",
    slug: "freiberg",
    plz: "09599",
    bundesland: "Sachsen",
    population: 43670,
    annualYieldKwhPerKwp: 1041.8,
    monthlyShare: [0.031320, 0.050345, 0.080523, 0.114770, 0.120827, 0.119138, 0.123659, 0.113906, 0.094661, 0.071855, 0.044230, 0.034766],
    rank: 126,
  },
  {
    name: "Marburg an der Lahn",
    slug: "marburg-an-der-lahn",
    plz: "35039",
    bundesland: "Hessen",
    population: 78895,
    annualYieldKwhPerKwp: 1040.7,
    monthlyShare: [0.032996, 0.051944, 0.087832, 0.118185, 0.122317, 0.123998, 0.125026, 0.115600, 0.096153, 0.065684, 0.033832, 0.026433],
    rank: 127,
  },
  {
    name: "Erfurt",
    slug: "erfurt",
    plz: "99084",
    bundesland: "Thüringen",
    population: 218793,
    annualYieldKwhPerKwp: 1040.6,
    monthlyShare: [0.034749, 0.049317, 0.085604, 0.115471, 0.121179, 0.120891, 0.123341, 0.112338, 0.094944, 0.067864, 0.041995, 0.032308],
    rank: 128,
  },
  {
    name: "Weinheim",
    slug: "weinheim",
    plz: "69469",
    bundesland: "Baden-Württemberg",
    population: 43325,
    annualYieldKwhPerKwp: 1040.6,
    monthlyShare: [0.037151, 0.052815, 0.085719, 0.115846, 0.118267, 0.120180, 0.122447, 0.113645, 0.097087, 0.067864, 0.039861, 0.029118],
    rank: 129,
  },
  {
    name: "Hürth",
    slug: "huerth",
    plz: "50354",
    bundesland: "Nordrhein-Westfalen",
    population: 54678,
    annualYieldKwhPerKwp: 1038.6,
    monthlyShare: [0.037446, 0.053276, 0.086987, 0.114564, 0.120331, 0.118916, 0.120033, 0.110519, 0.094834, 0.069607, 0.042550, 0.030937],
    rank: 130,
  },
  {
    name: "Chemnitz",
    slug: "chemnitz",
    plz: "09130",
    bundesland: "Sachsen",
    population: 247220,
    annualYieldKwhPerKwp: 1038.2,
    monthlyShare: [0.033268, 0.052184, 0.081263, 0.114049, 0.119192, 0.117429, 0.122939, 0.113278, 0.093601, 0.072681, 0.044807, 0.035310],
    rank: 131,
  },
  {
    name: "Wolfenbüttel",
    slug: "wolfenbuettel",
    plz: "38281",
    bundesland: "Niedersachsen",
    population: 54740,
    annualYieldKwhPerKwp: 1038.1,
    monthlyShare: [0.031624, 0.049762, 0.084679, 0.118181, 0.123836, 0.125107, 0.123903, 0.113558, 0.095930, 0.067765, 0.037384, 0.028271],
    rank: 132,
  },
  {
    name: "Aachen",
    slug: "aachen",
    plz: "52062",
    bundesland: "Nordrhein-Westfalen",
    population: 265208,
    annualYieldKwhPerKwp: 1037,
    monthlyShare: [0.037116, 0.051995, 0.084713, 0.113295, 0.119524, 0.119524, 0.121212, 0.110016, 0.096024, 0.069940, 0.044531, 0.032111],
    rank: 133,
  },
  {
    name: "Wesel",
    slug: "wesel",
    plz: "46483",
    bundesland: "Nordrhein-Westfalen",
    population: 61685,
    annualYieldKwhPerKwp: 1037,
    monthlyShare: [0.034282, 0.050926, 0.086616, 0.115883, 0.123723, 0.121457, 0.122441, 0.112180, 0.094273, 0.068737, 0.040801, 0.028679],
    rank: 134,
  },
  {
    name: "Peine",
    slug: "peine",
    plz: "31226",
    bundesland: "Niedersachsen",
    population: 49953,
    annualYieldKwhPerKwp: 1036.7,
    monthlyShare: [0.030106, 0.048483, 0.083354, 0.119326, 0.125200, 0.126647, 0.124072, 0.114444, 0.097033, 0.067496, 0.036685, 0.027155],
    rank: 135,
  },
  {
    name: "Meerbusch",
    slug: "meerbusch",
    plz: "40667",
    bundesland: "Nordrhein-Westfalen",
    population: 54826,
    annualYieldKwhPerKwp: 1036.6,
    monthlyShare: [0.036061, 0.052287, 0.087113, 0.114558, 0.122507, 0.120887, 0.121620, 0.111201, 0.094107, 0.068397, 0.041714, 0.029549],
    rank: 136,
  },
  {
    name: "Bonn",
    slug: "bonn",
    plz: "53125",
    bundesland: "Nordrhein-Westfalen",
    population: 330579,
    annualYieldKwhPerKwp: 1035.5,
    monthlyShare: [0.038221, 0.053537, 0.086563, 0.113910, 0.118304, 0.119144, 0.121356, 0.110859, 0.095408, 0.069277, 0.041949, 0.031471],
    rank: 137,
  },
  {
    name: "Lehrte",
    slug: "lehrte",
    plz: "31275",
    bundesland: "Niedersachsen",
    population: 43920,
    annualYieldKwhPerKwp: 1035,
    monthlyShare: [0.029545, 0.048703, 0.083775, 0.119358, 0.125686, 0.125841, 0.124865, 0.113841, 0.096615, 0.067389, 0.036520, 0.027864],
    rank: 138,
  },
  {
    name: "Dormagen",
    slug: "dormagen",
    plz: "41539",
    bundesland: "Nordrhein-Westfalen",
    population: 63582,
    annualYieldKwhPerKwp: 1034.9,
    monthlyShare: [0.036814, 0.052420, 0.087195, 0.114869, 0.122087, 0.120966, 0.120463, 0.110501, 0.094452, 0.068508, 0.041346, 0.030379],
    rank: 139,
  },
  {
    name: "Troisdorf",
    slug: "troisdorf",
    plz: "53840",
    bundesland: "Nordrhein-Westfalen",
    population: 74749,
    annualYieldKwhPerKwp: 1034.8,
    monthlyShare: [0.038346, 0.053876, 0.087362, 0.114160, 0.119262, 0.119523, 0.120257, 0.111106, 0.095015, 0.068701, 0.041091, 0.031301],
    rank: 140,
  },
  {
    name: "Rheda-Wiedenbrück",
    slug: "rheda-wiedenbrueck",
    plz: "33378",
    bundesland: "Nordrhein-Westfalen",
    population: 46123,
    annualYieldKwhPerKwp: 1034.4,
    monthlyShare: [0.032356, 0.050549, 0.086878, 0.115560, 0.123999, 0.123352, 0.122288, 0.112853, 0.094090, 0.069120, 0.040215, 0.028740],
    rank: 141,
  },
  {
    name: "Braunschweig",
    slug: "braunschweig",
    plz: "38100",
    bundesland: "Niedersachsen",
    population: 244715,
    annualYieldKwhPerKwp: 1034.2,
    monthlyShare: [0.031192, 0.049438, 0.084672, 0.118697, 0.123909, 0.125543, 0.124479, 0.113824, 0.095878, 0.067587, 0.036781, 0.028002],
    rank: 142,
  },
  {
    name: "Moers",
    slug: "moers",
    plz: "47441",
    bundesland: "Nordrhein-Westfalen",
    population: 103487,
    annualYieldKwhPerKwp: 1034,
    monthlyShare: [0.035812, 0.051315, 0.086518, 0.115308, 0.122736, 0.120270, 0.122726, 0.111508, 0.093655, 0.069090, 0.041499, 0.029565],
    rank: 143,
  },
  {
    name: "Fulda",
    slug: "fulda",
    plz: "36037",
    bundesland: "Hessen",
    population: 63760,
    annualYieldKwhPerKwp: 1034,
    monthlyShare: [0.034208, 0.050689, 0.086328, 0.116813, 0.120749, 0.120778, 0.125585, 0.115188, 0.095835, 0.068213, 0.038357, 0.027254],
    rank: 144,
  },
  {
    name: "Kleve",
    slug: "kleve",
    plz: "47533",
    bundesland: "Nordrhein-Westfalen",
    population: 49072,
    annualYieldKwhPerKwp: 1031.1,
    monthlyShare: [0.033507, 0.050285, 0.085993, 0.117483, 0.123515, 0.122089, 0.122768, 0.112546, 0.094721, 0.068042, 0.041110, 0.027940],
    rank: 145,
  },
  {
    name: "Neubrandenburg",
    slug: "neubrandenburg",
    plz: "17033",
    bundesland: "Mecklenburg-Vorpommern",
    population: 68082,
    annualYieldKwhPerKwp: 1029.3,
    monthlyShare: [0.028097, 0.046673, 0.080950, 0.123183, 0.129479, 0.128711, 0.125194, 0.118005, 0.098360, 0.066532, 0.033217, 0.021598],
    rank: 146,
  },
  {
    name: "Unna",
    slug: "unna",
    plz: "59425",
    bundesland: "Nordrhein-Westfalen",
    population: 66734,
    annualYieldKwhPerKwp: 1029.2,
    monthlyShare: [0.033948, 0.051427, 0.085123, 0.114553, 0.122909, 0.121441, 0.121548, 0.113435, 0.094392, 0.069217, 0.042518, 0.029488],
    rank: 147,
  },
  {
    name: "Garbsen",
    slug: "garbsen",
    plz: "30823",
    bundesland: "Niedersachsen",
    population: 63355,
    annualYieldKwhPerKwp: 1029.1,
    monthlyShare: [0.029473, 0.049345, 0.084250, 0.117668, 0.125724, 0.125462, 0.124062, 0.114189, 0.096465, 0.068255, 0.036887, 0.028219],
    rank: 148,
  },
  {
    name: "Bergkamen",
    slug: "bergkamen",
    plz: "59192",
    bundesland: "Nordrhein-Westfalen",
    population: 52329,
    annualYieldKwhPerKwp: 1028.4,
    monthlyShare: [0.034071, 0.050659, 0.086160, 0.114620, 0.123741, 0.121339, 0.121203, 0.112792, 0.094415, 0.069474, 0.041821, 0.029705],
    rank: 149,
  },
  {
    name: "Hildesheim",
    slug: "hildesheim",
    plz: "31134",
    bundesland: "Niedersachsen",
    population: 103052,
    annualYieldKwhPerKwp: 1028.2,
    monthlyShare: [0.031307, 0.049231, 0.084078, 0.117836, 0.123623, 0.124294, 0.124809, 0.113965, 0.096323, 0.068527, 0.037619, 0.028389],
    rank: 150,
  },
  {
    name: "Plauen",
    slug: "plauen",
    plz: "08523",
    bundesland: "Sachsen",
    population: 66412,
    annualYieldKwhPerKwp: 1028.2,
    monthlyShare: [0.031599, 0.049435, 0.083796, 0.116776, 0.122378, 0.120481, 0.125957, 0.114714, 0.095292, 0.069451, 0.039622, 0.030500],
    rank: 151,
  },
  {
    name: "Kamen",
    slug: "kamen",
    plz: "59174",
    bundesland: "Nordrhein-Westfalen",
    population: 45927,
    annualYieldKwhPerKwp: 1028,
    monthlyShare: [0.033823, 0.051167, 0.085174, 0.114454, 0.122956, 0.121584, 0.121672, 0.113559, 0.094425, 0.069289, 0.042451, 0.029445],
    rank: 152,
  },
  {
    name: "Düsseldorf",
    slug: "duesseldorf",
    plz: "40212",
    bundesland: "Nordrhein-Westfalen",
    population: 618685,
    annualYieldKwhPerKwp: 1027.6,
    monthlyShare: [0.036580, 0.052159, 0.087493, 0.114984, 0.122711, 0.120784, 0.121271, 0.110790, 0.093897, 0.068518, 0.041163, 0.029651],
    rank: 153,
  },
  {
    name: "Monheim am Rhein",
    slug: "monheim-am-rhein",
    plz: "40789",
    bundesland: "Nordrhein-Westfalen",
    population: 43038,
    annualYieldKwhPerKwp: 1027.6,
    monthlyShare: [0.036813, 0.052548, 0.087162, 0.114973, 0.121951, 0.120861, 0.120754, 0.110935, 0.094441, 0.068332, 0.041143, 0.030089],
    rank: 154,
  },
  {
    name: "Ahlen",
    slug: "ahlen",
    plz: "59227",
    bundesland: "Nordrhein-Westfalen",
    population: 55280,
    annualYieldKwhPerKwp: 1027.4,
    monthlyShare: [0.033063, 0.051157, 0.087199, 0.115230, 0.123815, 0.121586, 0.122550, 0.113021, 0.094275, 0.069076, 0.040646, 0.028382],
    rank: 155,
  },
  {
    name: "Wolfsburg",
    slug: "wolfsburg",
    plz: "38440",
    bundesland: "Niedersachsen",
    population: 123064,
    annualYieldKwhPerKwp: 1027.1,
    monthlyShare: [0.030074, 0.048933, 0.083476, 0.119236, 0.124406, 0.126830, 0.124572, 0.115099, 0.096737, 0.067811, 0.036461, 0.026365],
    rank: 156,
  },
  {
    name: "Eschweiler",
    slug: "eschweiler",
    plz: "52249",
    bundesland: "Nordrhein-Westfalen",
    population: 55778,
    annualYieldKwhPerKwp: 1026.9,
    monthlyShare: [0.038603, 0.053239, 0.084743, 0.112858, 0.118408, 0.118165, 0.121047, 0.109897, 0.095553, 0.070671, 0.044631, 0.032185],
    rank: 157,
  },
  {
    name: "Bocholt",
    slug: "bocholt",
    plz: "46397",
    bundesland: "Nordrhein-Westfalen",
    population: 73943,
    annualYieldKwhPerKwp: 1026.2,
    monthlyShare: [0.033307, 0.049659, 0.086562, 0.117034, 0.124371, 0.122881, 0.122764, 0.112522, 0.093841, 0.068447, 0.040080, 0.028532],
    rank: 158,
  },
  {
    name: "Hof",
    slug: "hof",
    plz: "95028",
    bundesland: "Bayern",
    population: 49239,
    annualYieldKwhPerKwp: 1026.1,
    monthlyShare: [0.029763, 0.048553, 0.084281, 0.118157, 0.122017, 0.121890, 0.126870, 0.116764, 0.097389, 0.068435, 0.037706, 0.028175],
    rank: 159,
  },
  {
    name: "Stralsund",
    slug: "stralsund",
    plz: "18439",
    bundesland: "Mecklenburg-Vorpommern",
    population: 58976,
    annualYieldKwhPerKwp: 1025.2,
    monthlyShare: [0.026453, 0.044527, 0.080393, 0.124043, 0.132997, 0.132753, 0.128218, 0.116805, 0.096410, 0.065001, 0.031935, 0.020464],
    rank: 160,
  },
  {
    name: "Cuxhaven",
    slug: "cuxhaven",
    plz: "27472",
    bundesland: "Niedersachsen",
    population: 52677,
    annualYieldKwhPerKwp: 1024.2,
    monthlyShare: [0.026147, 0.046388, 0.087376, 0.123014, 0.134672, 0.127925, 0.128082, 0.114432, 0.092981, 0.064959, 0.032963, 0.021061],
    rank: 161,
  },
  {
    name: "Lünen",
    slug: "luenen",
    plz: "44534",
    bundesland: "Nordrhein-Westfalen",
    population: 91009,
    annualYieldKwhPerKwp: 1023.7,
    monthlyShare: [0.034405, 0.051509, 0.085924, 0.114555, 0.123386, 0.120992, 0.121422, 0.112758, 0.094412, 0.069053, 0.042004, 0.029579],
    rank: 162,
  },
  {
    name: "Sankt Augustin",
    slug: "sankt-augustin",
    plz: "53757",
    bundesland: "Nordrhein-Westfalen",
    population: 56094,
    annualYieldKwhPerKwp: 1023.4,
    monthlyShare: [0.037396, 0.052952, 0.086390, 0.114415, 0.119496, 0.119623, 0.122457, 0.111386, 0.095830, 0.068069, 0.040845, 0.031142],
    rank: 163,
  },
  {
    name: "Rostock",
    slug: "rostock",
    plz: "18106",
    bundesland: "Mecklenburg-Vorpommern",
    population: 198293,
    annualYieldKwhPerKwp: 1022.3,
    monthlyShare: [0.026754, 0.045574, 0.081865, 0.124378, 0.133661, 0.130785, 0.126344, 0.114928, 0.095482, 0.065402, 0.033014, 0.021814],
    rank: 164,
  },
  {
    name: "Wismar",
    slug: "wismar",
    plz: "23966",
    bundesland: "Mecklenburg-Vorpommern",
    population: 45255,
    annualYieldKwhPerKwp: 1021.4,
    monthlyShare: [0.026063, 0.046026, 0.083396, 0.123479, 0.132545, 0.130273, 0.125525, 0.114579, 0.096310, 0.066723, 0.033053, 0.022029],
    rank: 165,
  },
  {
    name: "Greifswald",
    slug: "greifswald",
    plz: "17491",
    bundesland: "Mecklenburg-Vorpommern",
    population: 52731,
    annualYieldKwhPerKwp: 1021.1,
    monthlyShare: [0.026315, 0.043081, 0.080168, 0.124463, 0.132503, 0.130995, 0.126813, 0.117588, 0.097717, 0.066369, 0.033121, 0.020869],
    rank: 166,
  },
  {
    name: "Gifhorn",
    slug: "gifhorn",
    plz: "38518",
    bundesland: "Niedersachsen",
    population: 43000,
    annualYieldKwhPerKwp: 1021,
    monthlyShare: [0.029354, 0.049286, 0.083460, 0.119524, 0.125459, 0.126399, 0.125479, 0.115204, 0.096340, 0.067122, 0.035711, 0.026661],
    rank: 167,
  },
  {
    name: "Stolberg",
    slug: "stolberg",
    plz: "52222",
    bundesland: "Nordrhein-Westfalen",
    population: 57684,
    annualYieldKwhPerKwp: 1019.7,
    monthlyShare: [0.036098, 0.052711, 0.085425, 0.114090, 0.119709, 0.119346, 0.122269, 0.111148, 0.096644, 0.070343, 0.043041, 0.029175],
    rank: 168,
  },
  {
    name: "Castrop-Rauxel",
    slug: "castrop-rauxel",
    plz: "44575",
    bundesland: "Nordrhein-Westfalen",
    population: 77924,
    annualYieldKwhPerKwp: 1019.2,
    monthlyShare: [0.033624, 0.051079, 0.085999, 0.114923, 0.123195, 0.121232, 0.122959, 0.113236, 0.094388, 0.068593, 0.041837, 0.028934],
    rank: 169,
  },
  {
    name: "Gütersloh",
    slug: "guetersloh",
    plz: "33330",
    bundesland: "Nordrhein-Westfalen",
    population: 96180,
    annualYieldKwhPerKwp: 1019,
    monthlyShare: [0.032032, 0.050040, 0.086763, 0.116165, 0.123928, 0.123575, 0.122750, 0.113329, 0.094555, 0.069383, 0.039324, 0.028156],
    rank: 170,
  },
  {
    name: "Soest",
    slug: "soest",
    plz: "59494",
    bundesland: "Nordrhein-Westfalen",
    population: 48037,
    annualYieldKwhPerKwp: 1018.5,
    monthlyShare: [0.033402, 0.051831, 0.086087, 0.115002, 0.122612, 0.121100, 0.120992, 0.112499, 0.094521, 0.070133, 0.041993, 0.029828],
    rank: 171,
  },
  {
    name: "Leverkusen",
    slug: "leverkusen",
    plz: "51373",
    bundesland: "Nordrhein-Westfalen",
    population: 162738,
    annualYieldKwhPerKwp: 1018.4,
    monthlyShare: [0.037244, 0.052905, 0.087616, 0.115247, 0.121885, 0.119960, 0.120726, 0.110505, 0.094175, 0.068331, 0.041319, 0.030086],
    rank: 172,
  },
  {
    name: "Dülmen",
    slug: "duelmen",
    plz: "48249",
    bundesland: "Nordrhein-Westfalen",
    population: 47495,
    annualYieldKwhPerKwp: 1018,
    monthlyShare: [0.032741, 0.050384, 0.087182, 0.116799, 0.124078, 0.120964, 0.123813, 0.113262, 0.093753, 0.069234, 0.039833, 0.027957],
    rank: 173,
  },
  {
    name: "Dortmund",
    slug: "dortmund",
    plz: "44289",
    bundesland: "Nordrhein-Westfalen",
    population: 588462,
    annualYieldKwhPerKwp: 1017.9,
    monthlyShare: [0.035052, 0.051910, 0.086382, 0.114086, 0.123035, 0.121188, 0.121080, 0.112779, 0.094035, 0.068630, 0.042253, 0.029570],
    rank: 174,
  },
  {
    name: "Essen",
    slug: "essen",
    plz: "45127",
    bundesland: "Nordrhein-Westfalen",
    population: 593085,
    annualYieldKwhPerKwp: 1017.2,
    monthlyShare: [0.034704, 0.051141, 0.085265, 0.114464, 0.122751, 0.121326, 0.123292, 0.113205, 0.093769, 0.068808, 0.041949, 0.029326],
    rank: 175,
  },
  {
    name: "Göttingen",
    slug: "goettingen",
    plz: "37079",
    bundesland: "Niedersachsen",
    population: 122149,
    annualYieldKwhPerKwp: 1017.2,
    monthlyShare: [0.030694, 0.048134, 0.086713, 0.118105, 0.124574, 0.123010, 0.124810, 0.114201, 0.097085, 0.068132, 0.037566, 0.026977],
    rank: 176,
  },
  {
    name: "Langenfeld",
    slug: "langenfeld",
    plz: "40764",
    bundesland: "Nordrhein-Westfalen",
    population: 59112,
    annualYieldKwhPerKwp: 1017,
    monthlyShare: [0.035890, 0.051651, 0.087049, 0.115643, 0.122762, 0.121759, 0.121307, 0.111228, 0.094306, 0.068338, 0.040747, 0.029321],
    rank: 177,
  },
  {
    name: "Münster",
    slug: "muenster",
    plz: "48079",
    bundesland: "Nordrhein-Westfalen",
    population: 308258,
    annualYieldKwhPerKwp: 1016.8,
    monthlyShare: [0.032277, 0.050215, 0.087596, 0.117571, 0.123875, 0.121751, 0.122931, 0.113982, 0.094539, 0.068664, 0.039082, 0.027517],
    rank: 178,
  },
  {
    name: "Hennef (Sieg)",
    slug: "hennef-sieg",
    plz: "53773",
    bundesland: "Nordrhein-Westfalen",
    population: 48002,
    annualYieldKwhPerKwp: 1016.8,
    monthlyShare: [0.034894, 0.051259, 0.085395, 0.116355, 0.120466, 0.121371, 0.123436, 0.113336, 0.096823, 0.068086, 0.039152, 0.029426],
    rank: 179,
  },
  {
    name: "Gelsenkirchen",
    slug: "gelsenkirchen",
    plz: "45879",
    bundesland: "Nordrhein-Westfalen",
    population: 270028,
    annualYieldKwhPerKwp: 1016.2,
    monthlyShare: [0.034915, 0.051585, 0.085753, 0.115088, 0.122882, 0.120609, 0.122813, 0.112608, 0.093458, 0.068954, 0.041932, 0.029404],
    rank: 180,
  },
  {
    name: "Ratingen",
    slug: "ratingen",
    plz: "40832",
    bundesland: "Nordrhein-Westfalen",
    population: 91606,
    annualYieldKwhPerKwp: 1015.4,
    monthlyShare: [0.035887, 0.051851, 0.087207, 0.115590, 0.123035, 0.121509, 0.121725, 0.111355, 0.094071, 0.067973, 0.040427, 0.029368],
    rank: 181,
  },
  {
    name: "Herne",
    slug: "herne",
    plz: "44623",
    bundesland: "Nordrhein-Westfalen",
    population: 172108,
    annualYieldKwhPerKwp: 1015.3,
    monthlyShare: [0.034760, 0.051090, 0.085210, 0.114916, 0.122727, 0.121151, 0.122826, 0.113439, 0.094301, 0.068495, 0.041615, 0.029470],
    rank: 182,
  },
  {
    name: "Bochum",
    slug: "bochum",
    plz: "44801",
    bundesland: "Nordrhein-Westfalen",
    population: 385729,
    annualYieldKwhPerKwp: 1014.1,
    monthlyShare: [0.034683, 0.051428, 0.084888, 0.114709, 0.123072, 0.121228, 0.122717, 0.113467, 0.094168, 0.068528, 0.041813, 0.029299],
    rank: 183,
  },
  {
    name: "Langenhagen",
    slug: "langenhagen",
    plz: "30851",
    bundesland: "Niedersachsen",
    population: 50439,
    annualYieldKwhPerKwp: 1014.1,
    monthlyShare: [0.031031, 0.049983, 0.085018, 0.118514, 0.125426, 0.124076, 0.124243, 0.113081, 0.096012, 0.066914, 0.037026, 0.028675],
    rank: 184,
  },
  {
    name: "Bünde",
    slug: "buende",
    plz: "32257",
    bundesland: "Nordrhein-Westfalen",
    population: 46365,
    annualYieldKwhPerKwp: 1014,
    monthlyShare: [0.031124, 0.049674, 0.085837, 0.117839, 0.125117, 0.122938, 0.123529, 0.114289, 0.096350, 0.068412, 0.038727, 0.026163],
    rank: 185,
  },
  {
    name: "Duisburg",
    slug: "duisburg",
    plz: "47051",
    bundesland: "Nordrhein-Westfalen",
    population: 504358,
    annualYieldKwhPerKwp: 1013.7,
    monthlyShare: [0.035247, 0.050991, 0.086179, 0.115113, 0.123597, 0.121486, 0.123399, 0.111996, 0.093874, 0.068541, 0.040890, 0.028687],
    rank: 186,
  },
  {
    name: "Neustadt am Rübenberge",
    slug: "neustadt-am-ruebenberge",
    plz: "31535",
    bundesland: "Niedersachsen",
    population: 44668,
    annualYieldKwhPerKwp: 1013.3,
    monthlyShare: [0.029479, 0.048408, 0.084272, 0.118557, 0.125357, 0.125534, 0.125495, 0.115093, 0.096766, 0.066655, 0.036565, 0.027821],
    rank: 187,
  },
  {
    name: "Emden",
    slug: "emden",
    plz: "26721",
    bundesland: "Niedersachsen",
    population: 51526,
    annualYieldKwhPerKwp: 1013.2,
    monthlyShare: [0.028048, 0.046484, 0.089060, 0.121934, 0.131251, 0.125221, 0.126079, 0.113644, 0.093333, 0.065413, 0.035529, 0.024002],
    rank: 188,
  },
  {
    name: "Oberhausen",
    slug: "oberhausen",
    plz: "46045",
    bundesland: "Nordrhein-Westfalen",
    population: 219176,
    annualYieldKwhPerKwp: 1012.3,
    monthlyShare: [0.034791, 0.050862, 0.085643, 0.115534, 0.123763, 0.121540, 0.123210, 0.112354, 0.093516, 0.068742, 0.041123, 0.028923],
    rank: 189,
  },
  {
    name: "Hilden",
    slug: "hilden",
    plz: "40721",
    bundesland: "Nordrhein-Westfalen",
    population: 56565,
    annualYieldKwhPerKwp: 1012.2,
    monthlyShare: [0.035666, 0.051770, 0.087466, 0.115672, 0.123033, 0.122232, 0.121422, 0.111078, 0.094342, 0.068111, 0.039914, 0.029293],
    rank: 190,
  },
  {
    name: "Erkrath",
    slug: "erkrath",
    plz: "40699",
    bundesland: "Nordrhein-Westfalen",
    population: 47815,
    annualYieldKwhPerKwp: 1011.5,
    monthlyShare: [0.035148, 0.051629, 0.087607, 0.115962, 0.123367, 0.122557, 0.121766, 0.111315, 0.094478, 0.068071, 0.039607, 0.028494],
    rank: 191,
  },
  {
    name: "Bottrop",
    slug: "bottrop",
    plz: "46236",
    bundesland: "Nordrhein-Westfalen",
    population: 119909,
    annualYieldKwhPerKwp: 1011.4,
    monthlyShare: [0.035102, 0.051159, 0.085875, 0.115628, 0.123350, 0.120977, 0.122727, 0.112721, 0.093222, 0.069066, 0.041351, 0.028823],
    rank: 192,
  },
  {
    name: "Bad Salzuflen",
    slug: "bad-salzuflen",
    plz: "32105",
    bundesland: "Nordrhein-Westfalen",
    population: 54899,
    annualYieldKwhPerKwp: 1011.2,
    monthlyShare: [0.031063, 0.050495, 0.085771, 0.117655, 0.124765, 0.123212, 0.123232, 0.114737, 0.095947, 0.067723, 0.038678, 0.026721],
    rank: 193,
  },
  {
    name: "Gladbeck",
    slug: "gladbeck",
    plz: "45964",
    bundesland: "Nordrhein-Westfalen",
    population: 75499,
    annualYieldKwhPerKwp: 1011.1,
    monthlyShare: [0.035091, 0.050807, 0.086283, 0.116340, 0.123392, 0.120682, 0.122719, 0.112453, 0.093602, 0.068698, 0.040946, 0.028989],
    rank: 194,
  },
  {
    name: "Dinslaken",
    slug: "dinslaken",
    plz: "46535",
    bundesland: "Nordrhein-Westfalen",
    population: 66993,
    annualYieldKwhPerKwp: 1010.3,
    monthlyShare: [0.034892, 0.050838, 0.086453, 0.115703, 0.124186, 0.121296, 0.122751, 0.112149, 0.093214, 0.068883, 0.040633, 0.029002],
    rank: 195,
  },
  {
    name: "Hannover",
    slug: "hannover",
    plz: "30159",
    bundesland: "Niedersachsen",
    population: 515140,
    annualYieldKwhPerKwp: 1010.1,
    monthlyShare: [0.031481, 0.049925, 0.084980, 0.118570, 0.125807, 0.124401, 0.124223, 0.112660, 0.095771, 0.066626, 0.037174, 0.028383],
    rank: 196,
  },
  {
    name: "Mülheim",
    slug: "muelheim",
    plz: "54486",
    bundesland: "Nordrhein-Westfalen",
    population: 173050,
    annualYieldKwhPerKwp: 1009.5,
    monthlyShare: [0.034237, 0.050860, 0.085711, 0.115529, 0.124227, 0.121493, 0.123990, 0.112300, 0.093894, 0.068602, 0.040458, 0.028699],
    rank: 197,
  },
  {
    name: "Dorsten",
    slug: "dorsten",
    plz: "46282",
    bundesland: "Nordrhein-Westfalen",
    population: 79981,
    annualYieldKwhPerKwp: 1008.7,
    monthlyShare: [0.035055, 0.050253, 0.086359, 0.116526, 0.123843, 0.121414, 0.122950, 0.112521, 0.093536, 0.068286, 0.040508, 0.028750],
    rank: 198,
  },
  {
    name: "Melle",
    slug: "melle",
    plz: "49324",
    bundesland: "Niedersachsen",
    population: 46436,
    annualYieldKwhPerKwp: 1008.7,
    monthlyShare: [0.029733, 0.048352, 0.085748, 0.118059, 0.125623, 0.124136, 0.125643, 0.115689, 0.095801, 0.067893, 0.037724, 0.025599],
    rank: 199,
  },
  {
    name: "Recklinghausen",
    slug: "recklinghausen",
    plz: "45657",
    bundesland: "Nordrhein-Westfalen",
    population: 122438,
    annualYieldKwhPerKwp: 1008,
    monthlyShare: [0.034504, 0.051061, 0.085842, 0.116318, 0.124195, 0.120634, 0.123223, 0.112231, 0.093580, 0.068769, 0.040843, 0.028799],
    rank: 200,
  },
  {
    name: "Witten",
    slug: "witten",
    plz: "58453",
    bundesland: "Nordrhein-Westfalen",
    population: 91808,
    annualYieldKwhPerKwp: 1007.6,
    monthlyShare: [0.034638, 0.051391, 0.085781, 0.114842, 0.122742, 0.121333, 0.122444, 0.113939, 0.093721, 0.068621, 0.041764, 0.028782],
    rank: 201,
  },
  {
    name: "Herten",
    slug: "herten",
    plz: "45699",
    bundesland: "Nordrhein-Westfalen",
    population: 65306,
    annualYieldKwhPerKwp: 1006.7,
    monthlyShare: [0.034906, 0.051077, 0.085784, 0.115972, 0.123581, 0.120770, 0.122925, 0.112277, 0.093711, 0.068759, 0.041114, 0.029125],
    rank: 202,
  },
  {
    name: "Hameln",
    slug: "hameln",
    plz: "31785",
    bundesland: "Niedersachsen",
    population: 58666,
    annualYieldKwhPerKwp: 1006.7,
    monthlyShare: [0.029514, 0.049084, 0.086019, 0.118682, 0.125149, 0.125159, 0.124712, 0.114937, 0.096708, 0.067591, 0.036249, 0.026196],
    rank: 203,
  },
  {
    name: "Rheine",
    slug: "rheine",
    plz: "48429",
    bundesland: "Nordrhein-Westfalen",
    population: 76491,
    annualYieldKwhPerKwp: 1005.9,
    monthlyShare: [0.030830, 0.050426, 0.086893, 0.118001, 0.124990, 0.122594, 0.124652, 0.114044, 0.094220, 0.068152, 0.038495, 0.026704],
    rank: 204,
  },
  {
    name: "Marl",
    slug: "marl",
    plz: "45768",
    bundesland: "Nordrhein-Westfalen",
    population: 91398,
    annualYieldKwhPerKwp: 1005.6,
    monthlyShare: [0.034597, 0.050468, 0.085800, 0.116519, 0.124186, 0.121312, 0.123331, 0.111755, 0.093527, 0.068955, 0.041070, 0.028481],
    rank: 205,
  },
  {
    name: "Minden",
    slug: "minden",
    plz: "32425",
    bundesland: "Nordrhein-Westfalen",
    population: 82879,
    annualYieldKwhPerKwp: 1004.9,
    monthlyShare: [0.030589, 0.049257, 0.084801, 0.117709, 0.125410, 0.124714, 0.124206, 0.114882, 0.096503, 0.066870, 0.038211, 0.026847],
    rank: 206,
  },
  {
    name: "Herford",
    slug: "herford",
    plz: "32052",
    bundesland: "Nordrhein-Westfalen",
    population: 64879,
    annualYieldKwhPerKwp: 1004.2,
    monthlyShare: [0.030661, 0.049960, 0.085650, 0.117855, 0.125284, 0.123173, 0.123989, 0.114738, 0.096007, 0.067606, 0.038727, 0.026349],
    rank: 207,
  },
  {
    name: "Gronau",
    slug: "gronau",
    plz: "48599",
    bundesland: "Nordrhein-Westfalen",
    population: 50547,
    annualYieldKwhPerKwp: 1004.1,
    monthlyShare: [0.030824, 0.049417, 0.087681, 0.118494, 0.125326, 0.123125, 0.124679, 0.114311, 0.093576, 0.067493, 0.038393, 0.026681],
    rank: 208,
  },
  {
    name: "Nordhorn",
    slug: "nordhorn",
    plz: "48529",
    bundesland: "Niedersachsen",
    population: 52803,
    annualYieldKwhPerKwp: 1002.6,
    monthlyShare: [0.030321, 0.049900, 0.087512, 0.118382, 0.125943, 0.122731, 0.125633, 0.113944, 0.094365, 0.066816, 0.037662, 0.026790],
    rank: 209,
  },
  {
    name: "Schwerte",
    slug: "schwerte",
    plz: "58239",
    bundesland: "Nordrhein-Westfalen",
    population: 50399,
    annualYieldKwhPerKwp: 1001.9,
    monthlyShare: [0.034393, 0.052398, 0.086323, 0.114787, 0.122153, 0.121375, 0.121464, 0.113630, 0.093638, 0.068717, 0.042198, 0.028924],
    rank: 210,
  },
  {
    name: "Velbert",
    slug: "velbert",
    plz: "42549",
    bundesland: "Nordrhein-Westfalen",
    population: 87669,
    annualYieldKwhPerKwp: 1001,
    monthlyShare: [0.032948, 0.049192, 0.086036, 0.117215, 0.124008, 0.122580, 0.123309, 0.113419, 0.094298, 0.068803, 0.040101, 0.028092],
    rank: 211,
  },
  {
    name: "Celle",
    slug: "celle",
    plz: "29229",
    bundesland: "Niedersachsen",
    population: 71010,
    annualYieldKwhPerKwp: 1000.3,
    monthlyShare: [0.029762, 0.048346, 0.083787, 0.119826, 0.125785, 0.127084, 0.126385, 0.114378, 0.096453, 0.066541, 0.035890, 0.025763],
    rank: 212,
  },
  {
    name: "Kassel",
    slug: "kassel",
    plz: "34132",
    bundesland: "Hessen",
    population: 197230,
    annualYieldKwhPerKwp: 1000.2,
    monthlyShare: [0.032075, 0.049292, 0.087605, 0.119290, 0.124289, 0.122919, 0.124649, 0.114351, 0.096854, 0.066829, 0.035744, 0.026106],
    rank: 213,
  },
  {
    name: "Menden",
    slug: "menden",
    plz: "58706",
    bundesland: "Nordrhein-Westfalen",
    population: 52452,
    annualYieldKwhPerKwp: 997.9,
    monthlyShare: [0.034403, 0.052572, 0.087075, 0.114364, 0.122240, 0.120146, 0.122000, 0.113532, 0.093239, 0.069057, 0.041969, 0.029403],
    rank: 214,
  },
  {
    name: "Bremerhaven",
    slug: "bremerhaven",
    plz: "27568",
    bundesland: "Bremen",
    population: 118610,
    annualYieldKwhPerKwp: 997.3,
    monthlyShare: [0.027484, 0.047709, 0.086875, 0.122572, 0.132319, 0.125550, 0.125851, 0.115774, 0.094346, 0.065397, 0.033611, 0.022511],
    rank: 215,
  },
  {
    name: "Hattingen",
    slug: "hattingen",
    plz: "45525",
    bundesland: "Nordrhein-Westfalen",
    population: 56866,
    annualYieldKwhPerKwp: 996.4,
    monthlyShare: [0.033079, 0.049528, 0.084955, 0.116870, 0.123804, 0.122389, 0.123674, 0.113919, 0.094479, 0.068687, 0.040776, 0.027840],
    rank: 216,
  },
  {
    name: "Paderborn",
    slug: "paderborn",
    plz: "33098",
    bundesland: "Nordrhein-Westfalen",
    population: 142161,
    annualYieldKwhPerKwp: 996.1,
    monthlyShare: [0.030811, 0.048279, 0.085455, 0.117340, 0.124317, 0.123886, 0.124177, 0.115212, 0.095635, 0.069011, 0.038652, 0.027227],
    rank: 217,
  },
  {
    name: "Hagen",
    slug: "hagen",
    plz: "58095",
    bundesland: "Nordrhein-Westfalen",
    population: 198972,
    annualYieldKwhPerKwp: 995.9,
    monthlyShare: [0.034242, 0.051523, 0.086368, 0.115498, 0.122698, 0.121774, 0.122648, 0.114022, 0.093085, 0.068333, 0.041321, 0.028488],
    rank: 218,
  },
  {
    name: "Osnabrück",
    slug: "osnabrueck",
    plz: "49074",
    bundesland: "Niedersachsen",
    population: 166462,
    annualYieldKwhPerKwp: 995.5,
    monthlyShare: [0.030296, 0.049100, 0.086338, 0.118382, 0.125303, 0.123133, 0.125634, 0.114956, 0.094906, 0.067373, 0.037468, 0.027112],
    rank: 219,
  },
  {
    name: "Bergisch Gladbach",
    slug: "bergisch-gladbach",
    plz: "51465",
    bundesland: "Nordrhein-Westfalen",
    population: 106184,
    annualYieldKwhPerKwp: 995.2,
    monthlyShare: [0.036356, 0.051942, 0.086299, 0.115872, 0.122444, 0.122424, 0.121710, 0.112405, 0.095061, 0.067507, 0.039110, 0.028870],
    rank: 220,
  },
  {
    name: "Bad Oeynhausen",
    slug: "bad-oeynhausen",
    plz: "32547",
    bundesland: "Nordrhein-Westfalen",
    population: 49513,
    annualYieldKwhPerKwp: 995.2,
    monthlyShare: [0.029722, 0.048814, 0.083731, 0.118407, 0.126235, 0.124366, 0.124094, 0.115423, 0.096834, 0.067333, 0.038625, 0.026417],
    rank: 221,
  },
  {
    name: "Lübeck",
    slug: "luebeck",
    plz: "23539",
    bundesland: "Schleswig-Holstein",
    population: 212207,
    annualYieldKwhPerKwp: 994.8,
    monthlyShare: [0.026408, 0.044835, 0.081799, 0.122633, 0.132866, 0.129499, 0.127609, 0.114369, 0.096707, 0.067273, 0.033958, 0.022046],
    rank: 222,
  },
  {
    name: "Schwerin",
    slug: "schwerin",
    plz: "19053",
    bundesland: "Mecklenburg-Vorpommern",
    population: 96641,
    annualYieldKwhPerKwp: 992.9,
    monthlyShare: [0.026750, 0.046328, 0.083381, 0.122559, 0.131563, 0.129438, 0.126416, 0.114754, 0.097249, 0.065696, 0.033497, 0.022369],
    rank: 223,
  },
  {
    name: "Ibbenbüren",
    slug: "ibbenbueren",
    plz: "49477",
    bundesland: "Nordrhein-Westfalen",
    population: 50577,
    annualYieldKwhPerKwp: 991.5,
    monthlyShare: [0.029885, 0.048413, 0.086710, 0.119731, 0.126075, 0.123836, 0.125006, 0.114436, 0.095142, 0.067445, 0.038024, 0.025296],
    rank: 224,
  },
  {
    name: "Bremen",
    slug: "bremen",
    plz: "28215",
    bundesland: "Bremen",
    population: 546501,
    annualYieldKwhPerKwp: 991,
    monthlyShare: [0.027931, 0.048950, 0.084863, 0.120877, 0.128233, 0.124984, 0.126134, 0.114308, 0.096023, 0.067547, 0.035570, 0.024581],
    rank: 225,
  },
  {
    name: "Delmenhorst",
    slug: "delmenhorst",
    plz: "27749",
    bundesland: "Niedersachsen",
    population: 75893,
    annualYieldKwhPerKwp: 989.9,
    monthlyShare: [0.027669, 0.049348, 0.085443, 0.120275, 0.128296, 0.124972, 0.126184, 0.115688, 0.095596, 0.067330, 0.034741, 0.024457],
    rank: 226,
  },
  {
    name: "Siegen",
    slug: "siegen",
    plz: "57072",
    bundesland: "Nordrhein-Westfalen",
    population: 107242,
    annualYieldKwhPerKwp: 989.7,
    monthlyShare: [0.033201, 0.050690, 0.087952, 0.117940, 0.120951, 0.122487, 0.125073, 0.115202, 0.096298, 0.067129, 0.036494, 0.026583],
    rank: 227,
  },
  {
    name: "Koblenz",
    slug: "koblenz",
    plz: "56073",
    bundesland: "Rheinland-Pfalz",
    population: 107319,
    annualYieldKwhPerKwp: 987.9,
    monthlyShare: [0.026965, 0.049426, 0.089560, 0.123358, 0.125058, 0.125706, 0.129664, 0.118641, 0.100128, 0.063971, 0.030720, 0.016803],
    rank: 228,
  },
  {
    name: "Lüneburg",
    slug: "lueneburg",
    plz: "21335",
    bundesland: "Niedersachsen",
    population: 71260,
    annualYieldKwhPerKwp: 987.3,
    monthlyShare: [0.027803, 0.048668, 0.082943, 0.120510, 0.129110, 0.127003, 0.126385, 0.114808, 0.096556, 0.067426, 0.035389, 0.023397],
    rank: 229,
  },
  {
    name: "Gummersbach",
    slug: "gummersbach",
    plz: "51643",
    bundesland: "Nordrhein-Westfalen",
    population: 53131,
    annualYieldKwhPerKwp: 985.6,
    monthlyShare: [0.031605, 0.049656, 0.087369, 0.117929, 0.123023, 0.123175, 0.124504, 0.115281, 0.096369, 0.066600, 0.037663, 0.026827],
    rank: 230,
  },
  {
    name: "Suhl",
    slug: "suhl",
    plz: "98527",
    bundesland: "Thüringen",
    population: 43509,
    annualYieldKwhPerKwp: 984.9,
    monthlyShare: [0.033589, 0.050942, 0.086775, 0.119115, 0.123704, 0.122161, 0.127055, 0.113804, 0.097649, 0.064507, 0.034391, 0.026309],
    rank: 231,
  },
  {
    name: "Bielefeld",
    slug: "bielefeld",
    plz: "33619",
    bundesland: "Nordrhein-Westfalen",
    population: 331906,
    annualYieldKwhPerKwp: 984.8,
    monthlyShare: [0.031225, 0.049198, 0.086292, 0.117831, 0.124726, 0.124056, 0.124614, 0.114247, 0.095441, 0.067821, 0.037683, 0.026868],
    rank: 232,
  },
  {
    name: "Solingen",
    slug: "solingen",
    plz: "42651",
    bundesland: "Nordrhein-Westfalen",
    population: 164359,
    annualYieldKwhPerKwp: 983.7,
    monthlyShare: [0.033954, 0.049365, 0.086511, 0.117242, 0.124013, 0.122874, 0.123321, 0.113247, 0.093942, 0.068009, 0.039484, 0.028037],
    rank: 233,
  },
  {
    name: "Kiel",
    slug: "kiel",
    plz: "24103",
    bundesland: "Schleswig-Holstein",
    population: 252668,
    annualYieldKwhPerKwp: 983.2,
    monthlyShare: [0.025345, 0.041750, 0.080673, 0.124203, 0.137292, 0.131882, 0.129054, 0.115670, 0.095400, 0.065031, 0.033156, 0.020545],
    rank: 234,
  },
  {
    name: "Lingen",
    slug: "lingen",
    plz: "49809",
    bundesland: "Niedersachsen",
    population: 51310,
    annualYieldKwhPerKwp: 982.1,
    monthlyShare: [0.030018, 0.049700, 0.086957, 0.119612, 0.125803, 0.123573, 0.126292, 0.113941, 0.094156, 0.066491, 0.037125, 0.026332],
    rank: 235,
  },
  {
    name: "Elmshorn",
    slug: "elmshorn",
    plz: "25336",
    bundesland: "Schleswig-Holstein",
    population: 48703,
    annualYieldKwhPerKwp: 980.1,
    monthlyShare: [0.026804, 0.045905, 0.082454, 0.122146, 0.132063, 0.127951, 0.128125, 0.114860, 0.096086, 0.066567, 0.034692, 0.022346],
    rank: 236,
  },
  {
    name: "Oldenburg",
    slug: "oldenburg",
    plz: "26122",
    bundesland: "Niedersachsen",
    population: 159218,
    annualYieldKwhPerKwp: 979.6,
    monthlyShare: [0.028746, 0.048631, 0.085615, 0.119934, 0.128284, 0.124793, 0.126120, 0.115381, 0.094169, 0.067659, 0.035340, 0.025326],
    rank: 237,
  },
  {
    name: "Remscheid",
    slug: "remscheid",
    plz: "42853",
    bundesland: "Nordrhein-Westfalen",
    population: 117118,
    annualYieldKwhPerKwp: 979.4,
    monthlyShare: [0.032960, 0.049348, 0.086361, 0.117248, 0.124854, 0.123333, 0.123823, 0.114052, 0.094499, 0.067441, 0.038453, 0.027630],
    rank: 238,
  },
  {
    name: "Wuppertal",
    slug: "wuppertal",
    plz: "42103",
    bundesland: "Nordrhein-Westfalen",
    population: 360797,
    annualYieldKwhPerKwp: 977.9,
    monthlyShare: [0.032417, 0.049015, 0.086719, 0.117531, 0.124802, 0.123135, 0.124025, 0.113860, 0.094266, 0.068209, 0.039044, 0.026977],
    rank: 239,
  },
  {
    name: "Wilhelmshaven",
    slug: "wilhelmshaven",
    plz: "26386",
    bundesland: "Niedersachsen",
    population: 84393,
    annualYieldKwhPerKwp: 975.8,
    monthlyShare: [0.027699, 0.046606, 0.086839, 0.122419, 0.132677, 0.126549, 0.125503, 0.115532, 0.094268, 0.065093, 0.032946, 0.023867],
    rank: 240,
  },
  {
    name: "Iserlohn",
    slug: "iserlohn",
    plz: "58636",
    bundesland: "Nordrhein-Westfalen",
    population: 91811,
    annualYieldKwhPerKwp: 974.2,
    monthlyShare: [0.032087, 0.051713, 0.087269, 0.116184, 0.123308, 0.121778, 0.123318, 0.114254, 0.093571, 0.068475, 0.040545, 0.027499],
    rank: 241,
  },
  {
    name: "Hamburg",
    slug: "hamburg",
    plz: "20038",
    bundesland: "Hamburg",
    population: 1973896,
    annualYieldKwhPerKwp: 973.6,
    monthlyShare: [0.027784, 0.047300, 0.084092, 0.122640, 0.130313, 0.126985, 0.128402, 0.113612, 0.096068, 0.065942, 0.033793, 0.023069],
    rank: 242,
  },
  {
    name: "Norderstedt",
    slug: "norderstedt",
    plz: "22846",
    bundesland: "Schleswig-Holstein",
    population: 82844,
    annualYieldKwhPerKwp: 972.8,
    monthlyShare: [0.027517, 0.047068, 0.082953, 0.121767, 0.130977, 0.128130, 0.127688, 0.113945, 0.096028, 0.066846, 0.034384, 0.022696],
    rank: 243,
  },
  {
    name: "Stade",
    slug: "stade",
    plz: "21683",
    bundesland: "Niedersachsen",
    population: 45634,
    annualYieldKwhPerKwp: 972.5,
    monthlyShare: [0.026376, 0.045800, 0.083179, 0.121751, 0.132126, 0.127005, 0.127067, 0.115509, 0.096866, 0.067179, 0.034685, 0.022458],
    rank: 244,
  },
  {
    name: "Arnsberg",
    slug: "arnsberg",
    plz: "59755",
    bundesland: "Nordrhein-Westfalen",
    population: 74879,
    annualYieldKwhPerKwp: 968.7,
    monthlyShare: [0.031207, 0.050697, 0.087385, 0.117116, 0.122814, 0.122112, 0.124135, 0.114679, 0.095055, 0.067926, 0.039063, 0.027810],
    rank: 245,
  },
  {
    name: "Lüdenscheid",
    slug: "luedenscheid",
    plz: "58507",
    bundesland: "Nordrhein-Westfalen",
    population: 79386,
    annualYieldKwhPerKwp: 961.9,
    monthlyShare: [0.032051, 0.049278, 0.087630, 0.118111, 0.122945, 0.123528, 0.124079, 0.115273, 0.094595, 0.066608, 0.038934, 0.026968],
    rank: 246,
  },
  {
    name: "Flensburg",
    slug: "flensburg",
    plz: "24937",
    bundesland: "Schleswig-Holstein",
    population: 85838,
    annualYieldKwhPerKwp: 960.6,
    monthlyShare: [0.025223, 0.039546, 0.079925, 0.125904, 0.140467, 0.134492, 0.131879, 0.116609, 0.093957, 0.063207, 0.031791, 0.016999],
    rank: 247,
  },
  {
    name: "Neumünster",
    slug: "neumuenster",
    plz: "24534",
    bundesland: "Schleswig-Holstein",
    population: 80196,
    annualYieldKwhPerKwp: 960,
    monthlyShare: [0.025083, 0.043489, 0.081592, 0.123445, 0.134591, 0.130831, 0.129049, 0.114602, 0.095529, 0.066238, 0.033791, 0.021760],
    rank: 248,
  },
  {
    name: "Detmold",
    slug: "detmold",
    plz: "32756",
    bundesland: "Nordrhein-Westfalen",
    population: 73680,
    annualYieldKwhPerKwp: 954.3,
    monthlyShare: [0.030694, 0.048069, 0.086297, 0.118626, 0.126056, 0.124442, 0.125081, 0.114969, 0.095027, 0.066994, 0.037464, 0.026282],
    rank: 249,
  },
  {
    name: "Goslar",
    slug: "goslar",
    plz: "38640",
    bundesland: "Niedersachsen",
    population: 43560,
    annualYieldKwhPerKwp: 949.5,
    monthlyShare: [0.032176, 0.051028, 0.086532, 0.119098, 0.123237, 0.123437, 0.124080, 0.113189, 0.096591, 0.066785, 0.037463, 0.026383],
    rank: 250,
  }
]
